/* tslint:disable */
/* eslint-disable */
/**
 * iLect
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Answer {
    'id': string;
    'problem': string;
    'code'?: string | null;
}
export interface Assessment {
    'id': number;
    'email': string | null;
    'summary'?: any;
    'details'?: any;
    'created_at': Date;
    'updated_at': Date;
    'course'?: string | null;
    'user'?: string | null;
}
/**
 * This serializer is just for type compatibility in OpenAPI since we are returning custom Response in \"AssessmentAnalysisDetail\" view, the OpenAPI is not able to recognize correct type for that view
 */
export interface AssessmentAnalysisDetailAPIResponse {
    'skills': Array<AssessmentAnalysisSerializerDetail>;
    'email': string;
    'certification': string;
    'technical_grade': string;
    'soft_grade': string;
    'overall_grade': string;
    'overall_skill_score': number;
    'overall_skill_zscore': number;
}
/**
 * This is used as for assessment detail page serializer, although in-addition to this serializer we add additional field in using Response in view AssessmentAnalysisDetail
 */
export interface AssessmentAnalysisSerializerDetail {
    'score': number;
    'skill': string;
    'avg_skill_score': number;
    'rank_outof': number;
    'rank': number;
    'skill_type'?: SkillTypeEnum;
    'zscore': number;
}


/**
 * This is used for assessment table api
 */
export interface AssessmentAnalysisSerializerList {
    'user': string;
    'email': string;
    'skills': Array<AssessmentAnalysisSerializerSkillInfo>;
    'overall_skill_zscore': number;
    'grade_label': string;
}
/**
 * This is used as nested serializer inside AssessmentAnalysisSerializerList
 */
export interface AssessmentAnalysisSerializerSkillInfo {
    'score': number;
    'skill': string;
}
export interface AssessmentAssignmentDetail {
    'id': string;
    'name': string;
    'score': number;
    'total_score': number;
    'user_rank': number;
    'total_rank': number;
    'zscore': number;
    'average': number;
}
export interface AssessmentAssignmentList {
    'user': string;
    'email': string;
    'assignments': Array<AssessmentAssignmentListChild>;
}
export interface AssessmentAssignmentListChild {
    'name': string;
    'score': number;
}
export interface AssessmentImport {
    'course_id': string;
    'csv_file': string;
}
export interface AssessmentList {
    'id': number;
    'course_id': string | null;
    'user_id': string | null;
    'email': string | null;
    'summary'?: any;
}
export interface Assignment {
    'id': string;
    'title': string;
    'description'?: string;
    'descending_leaderboard'?: boolean;
    'leaderboard_limit'?: number;
    'courses': Array<string>;
    'created_at': Date;
    'updated_at': Date;
}
/**
 * fetches assignment\'s user/course specific details (expiry, user\'s submission status)
 */
export interface AssignmentCourseSpecific {
    'id': string;
    'title': string;
    'description'?: string;
    'descending_leaderboard'?: boolean;
    'leaderboard_limit'?: number;
    'created_at': Date;
    'updated_at': Date;
    'submit_token': string;
    'submitted': boolean;
    'expiry_date': Date;
}
export interface AssignmentCourseTestCaseList {
    'testcase_id': string;
    'testcase_title': string;
    'test_type_title': string;
    'show_on_leaderboard'?: boolean | null;
    'immediate'?: boolean | null;
    'assigned_score': number;
    'updated_at': Date;
}
export interface AssignmentFileSubmission {
    'id': string;
    'filename'?: string;
    'url': string;
    'created_at': Date;
}
export interface Course {
    'id': string;
    'short_id': string;
    'title': string;
    'submission_interval_sec'?: number;
    'gapi_sa_email': string;
    'description'?: string;
    'workbook_config'?: string | null;
    'default_duration_minutes': number;
    'created_at': Date;
    'updated_at': Date;
    'active': boolean;
    'has_videos': boolean;
    'has_assessment': boolean;
    'workbook_cpu_limit_hours'?: number;
    'workbook_gpu_limit_hours'?: number;
}
export interface CourseList {
    'id': string;
    'title': string;
    'description'?: string;
    'workbook_config'?: string | null;
    'created_at': Date;
    'updated_at': Date;
    'created_by'?: string | null;
}
export interface CurrentUser {
    'id': string;
    'short_id': string;
    'email': string;
    'username': string;
    'last_login': Date | null;
    'date_joined': Date;
    /**
     * Designates whether the user can log into this admin site.
     */
    'is_staff': boolean;
    'editor_courses': Array<string>;
}
/**
 * Adds the user\'s short_id as a claim to issued JWTs, alongside the default user_id claim. Used for both explicit login (SIMPLE_JWT TOKEN_OBTAIN_SERIALIZER) and social login (dj-rest-auth JWT_TOKEN_CLAIMS_SERIALIZER) so every login path carries the claim.
 */
export interface CustomTokenObtainPair {
    'email': string;
    'password': string;
}
export interface Editor {
    'short_id': string;
    'username': string;
    'email': string;
    'first_name': string;
    'last_name': string;
    'name': string;
    'is_author': boolean;
}
export interface Evaluation {
    'id': string;
    'status'?: StatusEnum;
    'score'?: number;
    'created_at': Date;
    'updated_at': Date;
    'submission': string;
    'testcase'?: string | null;
    'created_by': string;
}


export interface Event {
    'title': string;
    'details'?: string | null;
    'date'?: Date;
    'days'?: number;
    'bgcolor'?: string;
}
export interface Exam {
    'id': string;
    'name': string;
    'start_at'?: Date | null;
    'end_at'?: Date | null;
    /**
     * Minutes
     */
    'duration'?: number | null;
    'enabled'?: boolean;
    'problems_count': number;
}
export interface ExamDetail {
    'id': string;
    'name': string;
    'start_at'?: Date | null;
    'end_at'?: Date | null;
    /**
     * Minutes
     */
    'duration'?: number | null;
    'enabled'?: boolean;
    'problems': Array<any>;
}
export interface Feedback {
    'course_id': string | null;
    'user_id': string | null;
    'feedback': string;
}
export interface ForumFileUpload {
    'id': string;
    'data': string;
    'filename'?: string;
    'url': string;
    'created_at': Date;
}
export interface ForumRecord {
    'id': string;
    'created_by_username': string;
    'title': string;
    'content': string;
    'is_draft'?: boolean;
    'is_deleted'?: boolean;
    'is_announcement'?: boolean;
    'created_at': Date;
    'updated_at': Date;
    'course'?: string | null;
    'parent_record'?: string | null;
    'created_by'?: string | null;
}
export interface ForumRecordWithFiles {
    'id': string;
    'created_by_username': string;
    'forum_file_uploads': Array<ForumFileUpload>;
    'title': string;
    'content': string;
    'is_draft'?: boolean;
    'is_deleted'?: boolean;
    'is_announcement'?: boolean;
    'created_at': Date;
    'updated_at': Date;
    'course'?: string | null;
    'parent_record'?: string | null;
    'created_by'?: string | null;
}
export interface ForumTemplate {
    'id': number;
    'name': string;
    'forum_title': string;
    'forum_content': string;
}
export interface GkeSessionsResponse {
    'uid': string;
    'course_short_id': string | null;
    'processor_type': string;
    'start_timestamp': Date;
    'end_timestamp': Date;
    'duration': string;
}
export interface GkeStatsResponse {
    'uid': string;
    'course_short_id': string | null;
    'session_count': number;
    'nog_usage_seconds': number;
    'g16_usage_seconds': number;
    'g32_usage_seconds': number;
}
/**
 * * `NOG` - No GPU * `G16` - GPU 16G * `G32` - GPU 32G
 */

export const GpuTypeEnum = {
    Nog: 'NOG',
    G16: 'G16',
    G32: 'G32',
} as const;

export type GpuTypeEnum = typeof GpuTypeEnum[keyof typeof GpuTypeEnum];


export interface Histogram {
    'distribution_range': number;
    'user_count': number;
}
/**
 * Serializer for JWT authentication.
 */
export interface JWT {
    'access': string;
    'refresh': string;
    'user': UserDetails;
}
export interface Login {
    'username'?: string;
    'email'?: string;
    'password': string;
}
export interface NestedEvaluation {
    'testcase_title': string;
    'testcase_score': number;
    'show_score': boolean;
    'status'?: StatusEnum;
    'score'?: number;
}


export interface PaginatedAssessmentListList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<AssessmentList>;
}
export interface PaginatedCourseListList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<CourseList>;
}
export interface PaginatedExamList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<Exam>;
}
export interface PaginatedForumRecordList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<ForumRecord>;
}
export interface PaginatedProblemList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<Problem>;
}
export interface PaginatedQuizCourseList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<QuizCourse>;
}
export interface PaginatedQuizListList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<QuizList>;
}
export interface PaginatedQuizSubmissionList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<QuizSubmission>;
}
export interface PaginatedSubmissionListList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<SubmissionList>;
}
export interface PaginatedTrainingList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<Training>;
}
export interface PaginatedUserBaseList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<UserBase>;
}
export interface PaginatedVideoStatsList {
    'count': number;
    'next'?: string | null;
    'previous'?: string | null;
    'results': Array<VideoStats>;
}
export interface PasswordChange {
    'new_password1': string;
    'new_password2': string;
}
/**
 * Serializer for confirming a password reset attempt.
 */
export interface PasswordResetConfirm {
    'new_password1': string;
    'new_password2': string;
    'uid': string;
    'token': string;
}
export interface PatchedAssignment {
    'id'?: string;
    'title'?: string;
    'description'?: string;
    'descending_leaderboard'?: boolean;
    'leaderboard_limit'?: number;
    'courses'?: Array<string>;
    'created_at'?: Date;
    'updated_at'?: Date;
}
export interface PatchedCourse {
    'id'?: string;
    'short_id'?: string;
    'title'?: string;
    'submission_interval_sec'?: number;
    'gapi_sa_email'?: string;
    'description'?: string;
    'workbook_config'?: string | null;
    'default_duration_minutes'?: number;
    'created_at'?: Date;
    'updated_at'?: Date;
    'active'?: boolean;
    'has_videos'?: boolean;
    'has_assessment'?: boolean;
    'workbook_cpu_limit_hours'?: number;
    'workbook_gpu_limit_hours'?: number;
}
export interface PatchedEvaluation {
    'id'?: string;
    'status'?: StatusEnum;
    'score'?: number;
    'created_at'?: Date;
    'updated_at'?: Date;
    'submission'?: string;
    'testcase'?: string | null;
    'created_by'?: string;
}


export interface PatchedForumRecordWithFiles {
    'id'?: string;
    'created_by_username'?: string;
    'forum_file_uploads'?: Array<ForumFileUpload>;
    'title'?: string;
    'content'?: string;
    'is_draft'?: boolean;
    'is_deleted'?: boolean;
    'is_announcement'?: boolean;
    'created_at'?: Date;
    'updated_at'?: Date;
    'course'?: string | null;
    'parent_record'?: string | null;
    'created_by'?: string | null;
}
export interface PatchedUser {
    'id'?: string;
    'name'?: string | null;
    'email'?: string;
    'username'?: string;
    'affiliation'?: string;
    'icon'?: string;
}
export interface PatchedVideoStats {
    'id'?: number;
    'video'?: string;
    'user'?: string;
    'email'?: string;
    'progress'?: any;
    'created_at'?: Date;
    'updated_at'?: Date;
}
export interface Problem {
    'id': string;
    'generator'?: string | null;
    'difficulty': number;
    'category'?: string | null;
    'description'?: any | null;
    'preprocess_code'?: string | null;
    'postprocess_code'?: string | null;
    'solution_template'?: string | null;
    'max_bytes'?: number | null;
    'validation'?: string | null;
    'validation_tests'?: string | null;
    'answer': { [key: string]: any; };
}
export interface ProgressReport {
    'course_title': string;
    'quizzes_all': number;
    'quizzes_completed': number;
    'assignments': number;
    'submissions': number;
}
export interface QuizCourse {
    'id': string;
    'course': string;
    'quiz': number;
    'quiz_title': string;
    'averaged_score': number;
    'total_score': number;
    'release_datetime'?: Date;
    'submission_expiry'?: Date;
}
export interface QuizDetail {
    'title': string;
    'questions'?: any;
}
export interface QuizList {
    'id': number;
    'title': string;
}
export interface QuizSubmission {
    'id': string;
    'quiz_id': number;
    'score'?: number;
    'created_at': Date;
    'created_by'?: string | null;
}
export interface QuizSubmissionCreate {
    'quiz_course': string | null;
    'user_answer'?: any;
    'comment'?: string | null;
    'score'?: number;
    'created_by'?: string | null;
}
export interface QuizSubmissionDetail {
    'id': string;
    'correct_answer': any;
    'comment'?: string | null;
    'score'?: number;
    'user_answer'?: any;
    'created_at': Date;
    'quiz_course'?: string | null;
    'created_by'?: string | null;
}
export interface Register {
    'username': string;
    'email': string;
    'password1': string;
    'password2': string;
}
export interface ResendEmailVerification {
    'email': string;
}
export interface RestAuthDetail {
    'detail': string;
}
export interface Roles {
    'name': string;
}
export interface SignedURL {
    'filename': string;
}
/**
 * * `TE` - Technical * `SO` - Soft
 */

export const SkillTypeEnum = {
    Te: 'TE',
    So: 'SO',
} as const;

export type SkillTypeEnum = typeof SkillTypeEnum[keyof typeof SkillTypeEnum];


export interface SocialLogin {
    'access_token'?: string;
    'code'?: string;
    'id_token'?: string;
}
/**
 * * `CO` - Completed * `CA` - Canceled * `SC` - Scheduled * `PD` - Pending * `EX` - Executing * `IF` - Invalidformat * `IE` - Internalerror * `WR` - Wrong * `CR` - Correct
 */

export const StatusEnum = {
    Co: 'CO',
    Ca: 'CA',
    Sc: 'SC',
    Pd: 'PD',
    Ex: 'EX',
    If: 'IF',
    Ie: 'IE',
    Wr: 'WR',
    Cr: 'CR',
} as const;

export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];


export interface Student {
    'id': string;
    'short_id': string;
    'username': string;
    'email': string;
    'first_name': string;
    'last_name': string;
    'name': string;
}
export interface SubmissionDetailed {
    'id': string;
    'submission_expiry': Date;
    'assignment_id': string;
    'assignment_title': string;
    'course_id': string;
    'course_title': string;
    'score': number;
    'status': StatusEnum;
    'is_final': boolean;
    'comment': string;
    'created_by_username': string | null;
    'created_by'?: string | null;
    'created_at': Date;
    'evaluations': Array<NestedEvaluation>;
}


export interface SubmissionList {
    'id': string;
    'assignment_id': string;
    'assignment_title': string;
    'course_id': string;
    'course_title': string;
    'score': number;
    'comment': string;
    'is_final': boolean;
    'is_late': boolean;
    'status': StatusEnum;
    'created_by_username': string | null;
    'created_by'?: string | null;
    'created_at': Date;
}


export interface SubmissionListAdmin {
    'id': string;
    'assignment_id': string;
    'assignment_title': string;
    'score': number;
    'comment': string;
    'is_final': boolean;
    'status': StatusEnum;
    'created_by_username': string | null;
    'created_by_email': string;
    'created_by'?: string | null;
    'created_at': Date;
}


export interface TokenRefresh {
    'access': string;
    'refresh': string;
}
export interface Training {
    'id': string;
    'name': string;
    'enabled'?: boolean;
    'problems_count': number;
}
export interface TrainingDetail {
    'id': string;
    'name': string;
    'enabled'?: boolean;
    'problems': Array<any>;
}
export interface User {
    'id': string;
    'name': string | null;
    'email': string;
    'username': string;
    'affiliation'?: string;
    'icon'?: string;
}
export interface UserBase {
    'id': string;
    'short_id': string;
    'email': string;
    'username': string;
    'last_login': Date | null;
    'date_joined': Date;
    /**
     * Designates whether the user can log into this admin site.
     */
    'is_staff': boolean;
}
/**
 * User model w/o password
 */
export interface UserDetails {
    'pk': string;
    'email': string;
    'first_name'?: string;
    'last_name'?: string;
}
export interface VerifyEmail {
    'key': string;
}
export interface VideoStats {
    'id': number;
    'video': string;
    'user': string;
    'email': string;
    'progress'?: any;
    'created_at': Date;
    'updated_at': Date;
}
export interface VimeoVideo {
    'video_id': string;
    'player_embed_url': string;
    'name': string;
    'video_created_time': Date;
    'thumbnail_url': string;
    'duration_seconds': number;
    'course': string;
    'platform': string;
}
export interface VimeoVideoNameOnly {
    'name': string;
}
export interface VimeoVideoSync {
    'course': string;
}
export interface WorkbookConfig {
    'id': string;
    'gpu_type'?: GpuTypeEnum;
    'default_duration_minutes'?: number;
    'maximum_duration_minutes'?: number;
    'public_dir'?: string;
    'image': string;
    'course_id': string;
    'course_title': string;
    'course_short_id': string;
    'is_launchable': boolean;
    'launchable_period_start'?: string;
    'launchable_period_end'?: string;
    'enable_workbook_limit': boolean;
}


export interface WorkbookConfigList {
    'id': string;
}
export interface Workshop {
    'range_from': number;
    'range_to': number;
    'score': number;
    'skill': string;
}

/**
 * AssessmentAnalysisApi - axios parameter creator
 */
export const AssessmentAnalysisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisExistenceCourseRetrieve: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentAnalysisExistenceCourseRetrieve', 'courseId', courseId)
            const localVarPath = `/api/AssessmentAnalysis/Existence/Course/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisFeedbackList: async (course?: string, user?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AssessmentAnalysis/Feedback/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AssessmentAnalysisList
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisList: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentAnalysisList', 'courseId', courseId)
            const localVarPath = `/api/AssessmentAnalysis/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AssessmentAnalysisDetail
         * @param {string} courseId 
         * @param {string} userId 
         * @param {string} [skillType] Filter by skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecific: async (courseId: string, userId: string, skillType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecific', 'courseId', courseId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecific', 'userId', userId)
            const localVarPath = `/api/AssessmentAnalysis/{course_id}/{user_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (skillType !== undefined) {
                localVarQueryParameter['skill_type'] = skillType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailAssignmentHistogram
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecificAssignmentHistogram: async (assignmentId: string, courseId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificAssignmentHistogram', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificAssignmentHistogram', 'courseId', courseId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificAssignmentHistogram', 'userId', userId)
            const localVarPath = `/api/AssessmentAnalysis/histogram/assignment/{course_id}/{user_id}/{assignment_id}`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailSkillHistogram
         * @param {string} courseId 
         * @param {string} skillName 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecificSkillHistogram: async (courseId: string, skillName: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificSkillHistogram', 'courseId', courseId)
            // verify required parameter 'skillName' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificSkillHistogram', 'skillName', skillName)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assessmentAnalysisUserSpecificSkillHistogram', 'userId', userId)
            const localVarPath = `/api/AssessmentAnalysis/histogram/skill/{course_id}/{user_id}/{skill_name}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{skill_name}', encodeURIComponent(String(skillName)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisWorkshopList: async (course?: string, user?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AssessmentAnalysis/Workshop/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentAnalysisApi - functional programming interface
 */
export const AssessmentAnalysisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentAnalysisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisExistenceCourseRetrieve(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisExistenceCourseRetrieve(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisExistenceCourseRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisFeedbackList(course?: string, user?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Feedback>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisFeedbackList(course, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisFeedbackList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AssessmentAnalysisList
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisList(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentAnalysisSerializerList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisList(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AssessmentAnalysisDetail
         * @param {string} courseId 
         * @param {string} userId 
         * @param {string} [skillType] Filter by skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisUserSpecific(courseId: string, userId: string, skillType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentAnalysisDetailAPIResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisUserSpecific(courseId, userId, skillType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisUserSpecific']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailAssignmentHistogram
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId: string, courseId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Histogram>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId, courseId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisUserSpecificAssignmentHistogram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailSkillHistogram
         * @param {string} courseId 
         * @param {string} skillName 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisUserSpecificSkillHistogram(courseId: string, skillName: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Histogram>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisUserSpecificSkillHistogram(courseId, skillName, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisUserSpecificSkillHistogram']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentAnalysisWorkshopList(course?: string, user?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Workshop>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentAnalysisWorkshopList(course, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentAnalysisApi.assessmentAnalysisWorkshopList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentAnalysisApi - factory interface
 */
export const AssessmentAnalysisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentAnalysisApiFp(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisExistenceCourseRetrieve(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.assessmentAnalysisExistenceCourseRetrieve(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisFeedbackList(course?: string, user?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Feedback>> {
            return localVarFp.assessmentAnalysisFeedbackList(course, user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AssessmentAnalysisList
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisList(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentAnalysisSerializerList>> {
            return localVarFp.assessmentAnalysisList(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AssessmentAnalysisDetail
         * @param {string} courseId 
         * @param {string} userId 
         * @param {string} [skillType] Filter by skill type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecific(courseId: string, userId: string, skillType?: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentAnalysisDetailAPIResponse> {
            return localVarFp.assessmentAnalysisUserSpecific(courseId, userId, skillType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailAssignmentHistogram
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId: string, courseId: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Histogram>> {
            return localVarFp.assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId, courseId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AssessmentAnalysisDetailSkillHistogram
         * @param {string} courseId 
         * @param {string} skillName 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisUserSpecificSkillHistogram(courseId: string, skillName: string, userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Histogram>> {
            return localVarFp.assessmentAnalysisUserSpecificSkillHistogram(courseId, skillName, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [user] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentAnalysisWorkshopList(course?: string, user?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Workshop>> {
            return localVarFp.assessmentAnalysisWorkshopList(course, user, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentAnalysisApi - object-oriented interface
 */
export class AssessmentAnalysisApi extends BaseAPI {
    /**
     * 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisExistenceCourseRetrieve(courseId: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisExistenceCourseRetrieve(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [course] 
     * @param {string} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisFeedbackList(course?: string, user?: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisFeedbackList(course, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AssessmentAnalysisList
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisList(courseId: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisList(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AssessmentAnalysisDetail
     * @param {string} courseId 
     * @param {string} userId 
     * @param {string} [skillType] Filter by skill type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisUserSpecific(courseId: string, userId: string, skillType?: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisUserSpecific(courseId, userId, skillType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AssessmentAnalysisDetailAssignmentHistogram
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId: string, courseId: string, userId: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisUserSpecificAssignmentHistogram(assignmentId, courseId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AssessmentAnalysisDetailSkillHistogram
     * @param {string} courseId 
     * @param {string} skillName 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisUserSpecificSkillHistogram(courseId: string, skillName: string, userId: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisUserSpecificSkillHistogram(courseId, skillName, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [course] 
     * @param {string} [user] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentAnalysisWorkshopList(course?: string, user?: string, options?: RawAxiosRequestConfig) {
        return AssessmentAnalysisApiFp(this.configuration).assessmentAnalysisWorkshopList(course, user, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssessmentsApi - axios parameter creator
 */
export const AssessmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {string} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsImportCreate: async (courseId: string, csvFile: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assessmentsImportCreate', 'courseId', courseId)
            // verify required parameter 'csvFile' is not null or undefined
            assertParamExists('assessmentsImportCreate', 'csvFile', csvFile)
            const localVarPath = `/api/assessments/import/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (courseId !== undefined) { 
                localVarFormParams.append('course_id', courseId as any);
            }

            if (csvFile !== undefined) { 
                localVarFormParams.append('csv_file', csvFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsList: async (course?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/assessments/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assessmentsRetrieve', 'id', id)
            const localVarPath = `/api/assessments/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentsApi - functional programming interface
 */
export const AssessmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssessmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {string} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentsImportCreate(courseId: string, csvFile: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentImport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsImportCreate(courseId, csvFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.assessmentsImportCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentsList(course?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAssessmentListList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsList(course, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.assessmentsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessmentsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assessment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessmentsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssessmentsApi.assessmentsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssessmentsApi - factory interface
 */
export const AssessmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssessmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {string} csvFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsImportCreate(courseId: string, csvFile: string, options?: RawAxiosRequestConfig): AxiosPromise<AssessmentImport> {
            return localVarFp.assessmentsImportCreate(courseId, csvFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsList(course?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedAssessmentListList> {
            return localVarFp.assessmentsList(course, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessmentsRetrieve(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Assessment> {
            return localVarFp.assessmentsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentsApi - object-oriented interface
 */
export class AssessmentsApi extends BaseAPI {
    /**
     * 
     * @param {string} courseId 
     * @param {string} csvFile 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentsImportCreate(courseId: string, csvFile: string, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).assessmentsImportCreate(courseId, csvFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [course] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentsList(course?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).assessmentsList(course, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assessmentsRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return AssessmentsApiFp(this.configuration).assessmentsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssignmentApi - axios parameter creator
 */
export const AssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId course_id required for finding submission_expiry
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseSpecificDetailRetrieve: async (courseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentCourseSpecificDetailRetrieve', 'courseId', courseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentCourseSpecificDetailRetrieve', 'id', id)
            const localVarPath = `/api/Assignment/{id}/CourseSpecificDetail/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseId !== undefined) {
                localVarQueryParameter['course_id'] = courseId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId all-assignments for course_id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseSpecificList: async (courseId: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentCourseSpecificList', 'courseId', courseId)
            const localVarPath = `/api/Assignment/CourseSpecific/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseId !== undefined) {
                localVarQueryParameter['course_id'] = courseId;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseTestCaseList: async (assignmentId: string, courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentCourseTestCaseList', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentCourseTestCaseList', 'courseId', courseId)
            const localVarPath = `/api/Assignment/{assignment_id}/{course_id}/TestCase/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCreate: async (assignment: Assignment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignment' is not null or undefined
            assertParamExists('assignmentCreate', 'assignment', assignment)
            const localVarPath = `/api/Assignment/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentDestroy', 'id', id)
            const localVarPath = `/api/Assignment/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {string} url 
         * @param {Date} createdAt 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadCreate: async (assignmentId: string, courseId: string, id: string, url: string, createdAt: Date, filename?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentFileUploadCreate', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentFileUploadCreate', 'courseId', courseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentFileUploadCreate', 'id', id)
            // verify required parameter 'url' is not null or undefined
            assertParamExists('assignmentFileUploadCreate', 'url', url)
            // verify required parameter 'createdAt' is not null or undefined
            assertParamExists('assignmentFileUploadCreate', 'createdAt', createdAt)
            const localVarPath = `/api/Assignment/{assignment_id}/{course_id}/FileUpload/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (id !== undefined) { 
                localVarFormParams.append('id', id as any);
            }

            if (filename !== undefined) { 
                localVarFormParams.append('filename', filename as any);
            }

            if (url !== undefined) { 
                localVarFormParams.append('url', url as any);
            }

            if (createdAt !== undefined) { 
                localVarFormParams.append('created_at', createdAt as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadDestroy: async (assignmentId: string, courseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentFileUploadDestroy', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentFileUploadDestroy', 'courseId', courseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentFileUploadDestroy', 'id', id)
            const localVarPath = `/api/Assignment/{assignment_id}/{course_id}/FileUpload/{id}/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadList: async (assignmentId: string, courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('assignmentFileUploadList', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentFileUploadList', 'courseId', courseId)
            const localVarPath = `/api/Assignment/{assignment_id}/{course_id}/FileUpload/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Array<string>} [courses] 
         * @param {string} [createdBy] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentList: async (courses?: Array<string>, createdBy?: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assignment/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courses) {
                localVarQueryParameter['courses'] = courses;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {PatchedAssignment} [patchedAssignment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentPartialUpdate: async (id: string, patchedAssignment?: PatchedAssignment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentPartialUpdate', 'id', id)
            const localVarPath = `/api/Assignment/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedAssignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentRetrieve', 'id', id)
            const localVarPath = `/api/Assignment/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId 
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentTotalScoreRetrieve: async (courseId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('assignmentTotalScoreRetrieve', 'courseId', courseId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentTotalScoreRetrieve', 'id', id)
            const localVarPath = `/api/Assignment/{id}/total_score/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseId !== undefined) {
                localVarQueryParameter['course_id'] = courseId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentUpdate: async (id: string, assignment: Assignment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignmentUpdate', 'id', id)
            // verify required parameter 'assignment' is not null or undefined
            assertParamExists('assignmentUpdate', 'assignment', assignment)
            const localVarPath = `/api/Assignment/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignmentApi - functional programming interface
 */
export const AssignmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId course_id required for finding submission_expiry
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentCourseSpecificDetailRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentCourseSpecific>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentCourseSpecificDetailRetrieve(courseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentCourseSpecificDetailRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId all-assignments for course_id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentCourseSpecificList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentCourseSpecific>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentCourseSpecificList(courseId, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentCourseSpecificList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentCourseTestCaseList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentCourseTestCaseList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentCourseTestCaseList(assignmentId, courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentCourseTestCaseList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentCreate(assignment: Assignment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assignment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentCreate(assignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {string} url 
         * @param {Date} createdAt 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentFileUploadCreate(assignmentId: string, courseId: string, id: string, url: string, createdAt: Date, filename?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignmentFileSubmission>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentFileUploadCreate(assignmentId, courseId, id, url, createdAt, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentFileUploadCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentFileUploadDestroy(assignmentId: string, courseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentFileUploadDestroy(assignmentId, courseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentFileUploadDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentFileUploadList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssignmentFileSubmission>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentFileUploadList(assignmentId, courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentFileUploadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Array<string>} [courses] 
         * @param {string} [createdBy] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentList(courses?: Array<string>, createdBy?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Assignment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentList(courses, createdBy, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {PatchedAssignment} [patchedAssignment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentPartialUpdate(id: string, patchedAssignment?: PatchedAssignment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assignment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentPartialUpdate(id, patchedAssignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assignment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId 
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentTotalScoreRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentTotalScoreRetrieve(courseId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentTotalScoreRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignmentUpdate(id: string, assignment: Assignment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Assignment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignmentUpdate(id, assignment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignmentApi.assignmentUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssignmentApi - factory interface
 */
export const AssignmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignmentApiFp(configuration)
    return {
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId course_id required for finding submission_expiry
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseSpecificDetailRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentCourseSpecific> {
            return localVarFp.assignmentCourseSpecificDetailRetrieve(courseId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId all-assignments for course_id
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseSpecificList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentCourseSpecific>> {
            return localVarFp.assignmentCourseSpecificList(courseId, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCourseTestCaseList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentCourseTestCaseList>> {
            return localVarFp.assignmentCourseTestCaseList(assignmentId, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentCreate(assignment: Assignment, options?: RawAxiosRequestConfig): AxiosPromise<Assignment> {
            return localVarFp.assignmentCreate(assignment, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {string} url 
         * @param {Date} createdAt 
         * @param {string} [filename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadCreate(assignmentId: string, courseId: string, id: string, url: string, createdAt: Date, filename?: string, options?: RawAxiosRequestConfig): AxiosPromise<AssignmentFileSubmission> {
            return localVarFp.assignmentFileUploadCreate(assignmentId, courseId, id, url, createdAt, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadDestroy(assignmentId: string, courseId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignmentFileUploadDestroy(assignmentId, courseId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentFileUploadList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssignmentFileSubmission>> {
            return localVarFp.assignmentFileUploadList(assignmentId, courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {Array<string>} [courses] 
         * @param {string} [createdBy] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentList(courses?: Array<string>, createdBy?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Assignment>> {
            return localVarFp.assignmentList(courses, createdBy, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {PatchedAssignment} [patchedAssignment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentPartialUpdate(id: string, patchedAssignment?: PatchedAssignment, options?: RawAxiosRequestConfig): AxiosPromise<Assignment> {
            return localVarFp.assignmentPartialUpdate(id, patchedAssignment, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Assignment> {
            return localVarFp.assignmentRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} courseId 
         * @param {string} id A UUID string identifying this assignment.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentTotalScoreRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.assignmentTotalScoreRetrieve(courseId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Query parameter \'course\' should be set when getting the list of assignments.
         * @param {string} id A UUID string identifying this assignment.
         * @param {Assignment} assignment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignmentUpdate(id: string, assignment: Assignment, options?: RawAxiosRequestConfig): AxiosPromise<Assignment> {
            return localVarFp.assignmentUpdate(id, assignment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssignmentApi - object-oriented interface
 */
export class AssignmentApi extends BaseAPI {
    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} courseId course_id required for finding submission_expiry
     * @param {string} id A UUID string identifying this assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentCourseSpecificDetailRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentCourseSpecificDetailRetrieve(courseId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} courseId all-assignments for course_id
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentCourseSpecificList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentCourseSpecificList(courseId, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentCourseTestCaseList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentCourseTestCaseList(assignmentId, courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {Assignment} assignment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentCreate(assignment: Assignment, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentCreate(assignment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} id A UUID string identifying this assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentDestroy(id: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {string} id 
     * @param {string} url 
     * @param {Date} createdAt 
     * @param {string} [filename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentFileUploadCreate(assignmentId: string, courseId: string, id: string, url: string, createdAt: Date, filename?: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentFileUploadCreate(assignmentId, courseId, id, url, createdAt, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentFileUploadDestroy(assignmentId: string, courseId: string, id: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentFileUploadDestroy(assignmentId, courseId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Viewset for file submissions. Note that there is no update mixin. We do not perform update on file submissions.
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentFileUploadList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentFileUploadList(assignmentId, courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {Array<string>} [courses] 
     * @param {string} [createdBy] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentList(courses?: Array<string>, createdBy?: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentList(courses, createdBy, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} id A UUID string identifying this assignment.
     * @param {PatchedAssignment} [patchedAssignment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentPartialUpdate(id: string, patchedAssignment?: PatchedAssignment, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentPartialUpdate(id, patchedAssignment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} id A UUID string identifying this assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} courseId 
     * @param {string} id A UUID string identifying this assignment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentTotalScoreRetrieve(courseId: string, id: string, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentTotalScoreRetrieve(courseId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Query parameter \'course\' should be set when getting the list of assignments.
     * @param {string} id A UUID string identifying this assignment.
     * @param {Assignment} assignment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignmentUpdate(id: string, assignment: Assignment, options?: RawAxiosRequestConfig) {
        return AssignmentApiFp(this.configuration).assignmentUpdate(id, assignment, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Override succeeding login only when logging in with email. Tell user who has already logged in with a Google account to login with that instead. This is for always refreshing the Google api credentials we might use for this user.
         * @param {Login} login 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailLoginCreate: async (login: Login, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'login' is not null or undefined
            assertParamExists('authEmailLoginCreate', 'login', login)
            const localVarPath = `/api/auth/Email/Login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(login, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers a new user.  Accepts the following POST parameters: username, email, password1, password2.
         * @param {Register} register 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationCreate: async (register: Register, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'register' is not null or undefined
            assertParamExists('authEmailRegistrationCreate', 'register', register)
            const localVarPath = `/api/auth/Email/Registration/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(register, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resends another email to an unverified email.  Accepts the following POST parameter: email.
         * @param {ResendEmailVerification} resendEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationResendEmailCreate: async (resendEmailVerification: ResendEmailVerification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendEmailVerification' is not null or undefined
            assertParamExists('authEmailRegistrationResendEmailCreate', 'resendEmailVerification', resendEmailVerification)
            const localVarPath = `/api/auth/Email/Registration/resend-email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendEmailVerification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies the email associated with the provided key.  Accepts the following POST parameter: key.
         * @param {VerifyEmail} verifyEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationVerifyEmailCreate: async (verifyEmail: VerifyEmail, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyEmail' is not null or undefined
            assertParamExists('authEmailRegistrationVerifyEmailCreate', 'verifyEmail', verifyEmail)
            const localVarPath = `/api/auth/Email/Registration/verify-email/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyEmail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordChange} passwordChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordChangeCreate: async (passwordChange: PasswordChange, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordChange' is not null or undefined
            assertParamExists('authPasswordChangeCreate', 'passwordChange', passwordChange)
            const localVarPath = `/api/auth/password/change/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetConfirmCreate: async (passwordResetConfirm: PasswordResetConfirm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetConfirm' is not null or undefined
            assertParamExists('authPasswordResetConfirmCreate', 'passwordResetConfirm', passwordResetConfirm)
            const localVarPath = `/api/auth/password/reset/confirm/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetConfirm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesListRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/RolesList/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLogin} [socialLogin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSocialLoginGoogleCreate: async (socialLogin?: SocialLogin, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/SocialLogin/Google/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLogin, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPair} customTokenObtainPair 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenCreate: async (customTokenObtainPair: CustomTokenObtainPair, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customTokenObtainPair' is not null or undefined
            assertParamExists('authTokenCreate', 'customTokenObtainPair', customTokenObtainPair)
            const localVarPath = `/api/auth/Token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customTokenObtainPair, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenRefreshCreate: async (tokenRefresh: TokenRefresh, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenRefresh' is not null or undefined
            assertParamExists('authTokenRefreshCreate', 'tokenRefresh', tokenRefresh)
            const localVarPath = `/api/auth/Token/Refresh/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRefresh, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authUserDestroy', 'id', id)
            const localVarPath = `/api/auth/User/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {PatchedUser} [patchedUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserPartialUpdate: async (id: string, patchedUser?: PatchedUser, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authUserPartialUpdate', 'id', id)
            const localVarPath = `/api/auth/User/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedUser, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authUserRetrieve', 'id', id)
            const localVarPath = `/api/auth/User/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {User} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserUpdate: async (id: string, user: User, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('authUserUpdate', 'id', id)
            // verify required parameter 'user' is not null or undefined
            assertParamExists('authUserUpdate', 'user', user)
            const localVarPath = `/api/auth/User/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(user, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [courseId] 
         * @param {boolean} [isStaff] 
         * @param {Date} [lastLoginGte] 
         * @param {Date} [lastLoginLte] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersList: async (courseId?: string, isStaff?: boolean, lastLoginGte?: Date, lastLoginLte?: Date, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseId !== undefined) {
                localVarQueryParameter['course_id'] = courseId;
            }

            if (isStaff !== undefined) {
                localVarQueryParameter['is_staff'] = isStaff;
            }

            if (lastLoginGte !== undefined) {
                localVarQueryParameter['last_login__gte'] = (lastLoginGte as any instanceof Date) ?
                    (lastLoginGte as any).toISOString() :
                    lastLoginGte;
            }

            if (lastLoginLte !== undefined) {
                localVarQueryParameter['last_login__lte'] = (lastLoginLte as any instanceof Date) ?
                    (lastLoginLte as any).toISOString() :
                    lastLoginLte;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersMeRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userShortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersRetrieve: async (userShortId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userShortId' is not null or undefined
            assertParamExists('authUsersRetrieve', 'userShortId', userShortId)
            const localVarPath = `/api/auth/users/{user_short_id}`
                .replace('{user_short_id}', encodeURIComponent(String(userShortId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Override succeeding login only when logging in with email. Tell user who has already logged in with a Google account to login with that instead. This is for always refreshing the Google api credentials we might use for this user.
         * @param {Login} login 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEmailLoginCreate(login: Login, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Login>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authEmailLoginCreate(login, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authEmailLoginCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers a new user.  Accepts the following POST parameters: username, email, password1, password2.
         * @param {Register} register 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEmailRegistrationCreate(register: Register, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWT>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authEmailRegistrationCreate(register, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authEmailRegistrationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resends another email to an unverified email.  Accepts the following POST parameter: email.
         * @param {ResendEmailVerification} resendEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEmailRegistrationResendEmailCreate(resendEmailVerification: ResendEmailVerification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authEmailRegistrationResendEmailCreate(resendEmailVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authEmailRegistrationResendEmailCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies the email associated with the provided key.  Accepts the following POST parameter: key.
         * @param {VerifyEmail} verifyEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEmailRegistrationVerifyEmailCreate(verifyEmail: VerifyEmail, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authEmailRegistrationVerifyEmailCreate(verifyEmail, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authEmailRegistrationVerifyEmailCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordChange} passwordChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPasswordChangeCreate(passwordChange: PasswordChange, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPasswordChangeCreate(passwordChange, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authPasswordChangeCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authPasswordResetConfirmCreate(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestAuthDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authPasswordResetConfirmCreate(passwordResetConfirm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authPasswordResetConfirmCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authRolesListRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Roles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authRolesListRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authRolesListRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLogin} [socialLogin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authSocialLoginGoogleCreate(socialLogin?: SocialLogin, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SocialLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authSocialLoginGoogleCreate(socialLogin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authSocialLoginGoogleCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPair} customTokenObtainPair 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authTokenCreate(customTokenObtainPair: CustomTokenObtainPair, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomTokenObtainPair>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenCreate(customTokenObtainPair, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authTokenCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authTokenRefreshCreate(tokenRefresh: TokenRefresh, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenRefresh>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenRefreshCreate(tokenRefresh, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authTokenRefreshCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUserDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUserDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {PatchedUser} [patchedUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserPartialUpdate(id: string, patchedUser?: PatchedUser, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUserPartialUpdate(id, patchedUser, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUserPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUserRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUserRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {User} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUserUpdate(id: string, user: User, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUserUpdate(id, user, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUserUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [courseId] 
         * @param {boolean} [isStaff] 
         * @param {Date} [lastLoginGte] 
         * @param {Date} [lastLoginLte] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUsersList(courseId?: string, isStaff?: boolean, lastLoginGte?: Date, lastLoginLte?: Date, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedUserBaseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUsersList(courseId, isStaff, lastLoginGte, lastLoginLte, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUsersList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUsersMeRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUsersMeRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUsersMeRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userShortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUsersRetrieve(userShortId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUsersRetrieve(userShortId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authUsersRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Override succeeding login only when logging in with email. Tell user who has already logged in with a Google account to login with that instead. This is for always refreshing the Google api credentials we might use for this user.
         * @param {Login} login 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailLoginCreate(login: Login, options?: RawAxiosRequestConfig): AxiosPromise<Login> {
            return localVarFp.authEmailLoginCreate(login, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers a new user.  Accepts the following POST parameters: username, email, password1, password2.
         * @param {Register} register 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationCreate(register: Register, options?: RawAxiosRequestConfig): AxiosPromise<JWT> {
            return localVarFp.authEmailRegistrationCreate(register, options).then((request) => request(axios, basePath));
        },
        /**
         * Resends another email to an unverified email.  Accepts the following POST parameter: email.
         * @param {ResendEmailVerification} resendEmailVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationResendEmailCreate(resendEmailVerification: ResendEmailVerification, options?: RawAxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.authEmailRegistrationResendEmailCreate(resendEmailVerification, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies the email associated with the provided key.  Accepts the following POST parameter: key.
         * @param {VerifyEmail} verifyEmail 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEmailRegistrationVerifyEmailCreate(verifyEmail: VerifyEmail, options?: RawAxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.authEmailRegistrationVerifyEmailCreate(verifyEmail, options).then((request) => request(axios, basePath));
        },
        /**
         * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordChange} passwordChange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordChangeCreate(passwordChange: PasswordChange, options?: RawAxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.authPasswordChangeCreate(passwordChange, options).then((request) => request(axios, basePath));
        },
        /**
         * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
         * @param {PasswordResetConfirm} passwordResetConfirm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetConfirmCreate(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig): AxiosPromise<RestAuthDetail> {
            return localVarFp.authPasswordResetConfirmCreate(passwordResetConfirm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRolesListRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<Roles> {
            return localVarFp.authRolesListRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
         * @param {SocialLogin} [socialLogin] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSocialLoginGoogleCreate(socialLogin?: SocialLogin, options?: RawAxiosRequestConfig): AxiosPromise<SocialLogin> {
            return localVarFp.authSocialLoginGoogleCreate(socialLogin, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
         * @param {CustomTokenObtainPair} customTokenObtainPair 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenCreate(customTokenObtainPair: CustomTokenObtainPair, options?: RawAxiosRequestConfig): AxiosPromise<CustomTokenObtainPair> {
            return localVarFp.authTokenCreate(customTokenObtainPair, options).then((request) => request(axios, basePath));
        },
        /**
         * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
         * @param {TokenRefresh} tokenRefresh 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenRefreshCreate(tokenRefresh: TokenRefresh, options?: RawAxiosRequestConfig): AxiosPromise<TokenRefresh> {
            return localVarFp.authTokenRefreshCreate(tokenRefresh, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authUserDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {PatchedUser} [patchedUser] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserPartialUpdate(id: string, patchedUser?: PatchedUser, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.authUserPartialUpdate(id, patchedUser, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.authUserRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this user.
         * @param {User} user 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUserUpdate(id: string, user: User, options?: RawAxiosRequestConfig): AxiosPromise<User> {
            return localVarFp.authUserUpdate(id, user, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [courseId] 
         * @param {boolean} [isStaff] 
         * @param {Date} [lastLoginGte] 
         * @param {Date} [lastLoginLte] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersList(courseId?: string, isStaff?: boolean, lastLoginGte?: Date, lastLoginLte?: Date, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedUserBaseList> {
            return localVarFp.authUsersList(courseId, isStaff, lastLoginGte, lastLoginLte, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersMeRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUser> {
            return localVarFp.authUsersMeRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userShortId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUsersRetrieve(userShortId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserBase> {
            return localVarFp.authUsersRetrieve(userShortId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
    /**
     * Override succeeding login only when logging in with email. Tell user who has already logged in with a Google account to login with that instead. This is for always refreshing the Google api credentials we might use for this user.
     * @param {Login} login 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authEmailLoginCreate(login: Login, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authEmailLoginCreate(login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers a new user.  Accepts the following POST parameters: username, email, password1, password2.
     * @param {Register} register 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authEmailRegistrationCreate(register: Register, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authEmailRegistrationCreate(register, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resends another email to an unverified email.  Accepts the following POST parameter: email.
     * @param {ResendEmailVerification} resendEmailVerification 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authEmailRegistrationResendEmailCreate(resendEmailVerification: ResendEmailVerification, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authEmailRegistrationResendEmailCreate(resendEmailVerification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies the email associated with the provided key.  Accepts the following POST parameter: key.
     * @param {VerifyEmail} verifyEmail 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authEmailRegistrationVerifyEmailCreate(verifyEmail: VerifyEmail, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authEmailRegistrationVerifyEmailCreate(verifyEmail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Calls Django Auth SetPasswordForm save method.  Accepts the following POST parameters: new_password1, new_password2 Returns the success/fail message.
     * @param {PasswordChange} passwordChange 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authPasswordChangeCreate(passwordChange: PasswordChange, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPasswordChangeCreate(passwordChange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Password reset e-mail link is confirmed, therefore this resets the user\'s password.  Accepts the following POST parameters: token, uid,     new_password1, new_password2 Returns the success/fail message.
     * @param {PasswordResetConfirm} passwordResetConfirm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authPasswordResetConfirmCreate(passwordResetConfirm: PasswordResetConfirm, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authPasswordResetConfirmCreate(passwordResetConfirm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authRolesListRetrieve(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authRolesListRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * class used for social authentications example usage for facebook with access_token ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter -------------  example usage for facebook with code  ------------- from allauth.socialaccount.providers.facebook.views import FacebookOAuth2Adapter from allauth.socialaccount.providers.oauth2.client import OAuth2Client  class FacebookLogin(SocialLoginView):     adapter_class = FacebookOAuth2Adapter     client_class = OAuth2Client     callback_url = \'localhost:8000\' -------------
     * @param {SocialLogin} [socialLogin] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authSocialLoginGoogleCreate(socialLogin?: SocialLogin, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authSocialLoginGoogleCreate(socialLogin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a set of user credentials and returns an access and refresh JSON web token pair to prove the authentication of those credentials.
     * @param {CustomTokenObtainPair} customTokenObtainPair 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authTokenCreate(customTokenObtainPair: CustomTokenObtainPair, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authTokenCreate(customTokenObtainPair, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Takes a refresh type JSON web token and returns an access type JSON web token if the refresh token is valid.
     * @param {TokenRefresh} tokenRefresh 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authTokenRefreshCreate(tokenRefresh: TokenRefresh, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authTokenRefreshCreate(tokenRefresh, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUserDestroy(id: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUserDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this user.
     * @param {PatchedUser} [patchedUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUserPartialUpdate(id: string, patchedUser?: PatchedUser, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUserPartialUpdate(id, patchedUser, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUserRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUserRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this user.
     * @param {User} user 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUserUpdate(id: string, user: User, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUserUpdate(id, user, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [courseId] 
     * @param {boolean} [isStaff] 
     * @param {Date} [lastLoginGte] 
     * @param {Date} [lastLoginLte] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUsersList(courseId?: string, isStaff?: boolean, lastLoginGte?: Date, lastLoginLte?: Date, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUsersList(courseId, isStaff, lastLoginGte, lastLoginLte, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUsersMeRetrieve(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUsersMeRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userShortId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authUsersRetrieve(userShortId: string, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authUsersRetrieve(userShortId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CourseApi - axios parameter creator
 */
export const CourseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseCreate: async (course: Course, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'course' is not null or undefined
            assertParamExists('courseCreate', 'course', course)
            const localVarPath = `/api/Course/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(course, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseDestroy', 'id', id)
            const localVarPath = `/api/Course/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseList: async (limit?: number, offset?: number, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Course/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {PatchedCourse} [patchedCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursePartialUpdate: async (id: string, patchedCourse?: PatchedCourse, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coursePartialUpdate', 'id', id)
            const localVarPath = `/api/Course/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedCourse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseRetrieve', 'id', id)
            const localVarPath = `/api/Course/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseUpdate: async (id: string, course: Course, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('courseUpdate', 'id', id)
            // verify required parameter 'course' is not null or undefined
            assertParamExists('courseUpdate', 'course', course)
            const localVarPath = `/api/Course/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(course, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CourseApi - functional programming interface
 */
export const CourseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CourseApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseCreate(course: Course, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Course>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseCreate(course, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.courseCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.courseDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseList(limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedCourseListList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseList(limit, offset, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.courseList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {PatchedCourse} [patchedCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coursePartialUpdate(id: string, patchedCourse?: PatchedCourse, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Course>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coursePartialUpdate(id, patchedCourse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.coursePartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Course>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.courseRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async courseUpdate(id: string, course: Course, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Course>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.courseUpdate(id, course, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CourseApi.courseUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CourseApi - factory interface
 */
export const CourseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CourseApiFp(configuration)
    return {
        /**
         * 
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseCreate(course: Course, options?: RawAxiosRequestConfig): AxiosPromise<Course> {
            return localVarFp.courseCreate(course, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.courseDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseList(limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedCourseListList> {
            return localVarFp.courseList(limit, offset, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {PatchedCourse} [patchedCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coursePartialUpdate(id: string, patchedCourse?: PatchedCourse, options?: RawAxiosRequestConfig): AxiosPromise<Course> {
            return localVarFp.coursePartialUpdate(id, patchedCourse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Course> {
            return localVarFp.courseRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this course.
         * @param {Course} course 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        courseUpdate(id: string, course: Course, options?: RawAxiosRequestConfig): AxiosPromise<Course> {
            return localVarFp.courseUpdate(id, course, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CourseApi - object-oriented interface
 */
export class CourseApi extends BaseAPI {
    /**
     * 
     * @param {Course} course 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseCreate(course: Course, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).courseCreate(course, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this course.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseDestroy(id: string, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).courseDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseList(limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).courseList(limit, offset, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this course.
     * @param {PatchedCourse} [patchedCourse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coursePartialUpdate(id: string, patchedCourse?: PatchedCourse, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).coursePartialUpdate(id, patchedCourse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this course.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).courseRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this course.
     * @param {Course} course 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public courseUpdate(id: string, course: Course, options?: RawAxiosRequestConfig) {
        return CourseApiFp(this.configuration).courseUpdate(id, course, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EditorListApi - axios parameter creator
 */
export const EditorListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {Editor} editor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListCreate: async (courseId: string, editor: Editor, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('editorListCreate', 'courseId', courseId)
            // verify required parameter 'editor' is not null or undefined
            assertParamExists('editorListCreate', 'editor', editor)
            const localVarPath = `/api/EditorList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editor, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListDestroy: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('editorListDestroy', 'courseId', courseId)
            const localVarPath = `/api/EditorList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListRetrieve: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('editorListRetrieve', 'courseId', courseId)
            const localVarPath = `/api/EditorList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EditorListApi - functional programming interface
 */
export const EditorListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EditorListApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {Editor} editor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editorListCreate(courseId: string, editor: Editor, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Editor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editorListCreate(courseId, editor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditorListApi.editorListCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editorListDestroy(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editorListDestroy(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditorListApi.editorListDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editorListRetrieve(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Editor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editorListRetrieve(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditorListApi.editorListRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EditorListApi - factory interface
 */
export const EditorListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EditorListApiFp(configuration)
    return {
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {Editor} editor 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListCreate(courseId: string, editor: Editor, options?: RawAxiosRequestConfig): AxiosPromise<Editor> {
            return localVarFp.editorListCreate(courseId, editor, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListDestroy(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.editorListDestroy(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editorListRetrieve(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Editor> {
            return localVarFp.editorListRetrieve(courseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EditorListApi - object-oriented interface
 */
export class EditorListApi extends BaseAPI {
    /**
     * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
     * @param {string} courseId 
     * @param {Editor} editor 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editorListCreate(courseId: string, editor: Editor, options?: RawAxiosRequestConfig) {
        return EditorListApiFp(this.configuration).editorListCreate(courseId, editor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editorListDestroy(courseId: string, options?: RawAxiosRequestConfig) {
        return EditorListApiFp(this.configuration).editorListDestroy(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of editors who have permissions for the specified course. Add editors to the existing course.
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public editorListRetrieve(courseId: string, options?: RawAxiosRequestConfig) {
        return EditorListApiFp(this.configuration).editorListRetrieve(courseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EvaluationsApi - axios parameter creator
 */
export const EvaluationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {PatchedEvaluation} [patchedEvaluation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsPartialUpdate: async (id: string, patchedEvaluation?: PatchedEvaluation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('evaluationsPartialUpdate', 'id', id)
            const localVarPath = `/api/evaluations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedEvaluation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('evaluationsRetrieve', 'id', id)
            const localVarPath = `/api/evaluations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {Evaluation} evaluation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsUpdate: async (id: string, evaluation: Evaluation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('evaluationsUpdate', 'id', id)
            // verify required parameter 'evaluation' is not null or undefined
            assertParamExists('evaluationsUpdate', 'evaluation', evaluation)
            const localVarPath = `/api/evaluations/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(evaluation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvaluationsApi - functional programming interface
 */
export const EvaluationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EvaluationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {PatchedEvaluation} [patchedEvaluation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationsPartialUpdate(id: string, patchedEvaluation?: PatchedEvaluation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Evaluation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluationsPartialUpdate(id, patchedEvaluation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationsApi.evaluationsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Evaluation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluationsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationsApi.evaluationsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {Evaluation} evaluation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluationsUpdate(id: string, evaluation: Evaluation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Evaluation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluationsUpdate(id, evaluation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EvaluationsApi.evaluationsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EvaluationsApi - factory interface
 */
export const EvaluationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EvaluationsApiFp(configuration)
    return {
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {PatchedEvaluation} [patchedEvaluation] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsPartialUpdate(id: string, patchedEvaluation?: PatchedEvaluation, options?: RawAxiosRequestConfig): AxiosPromise<Evaluation> {
            return localVarFp.evaluationsPartialUpdate(id, patchedEvaluation, options).then((request) => request(axios, basePath));
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Evaluation> {
            return localVarFp.evaluationsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
         * @param {string} id 
         * @param {Evaluation} evaluation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluationsUpdate(id: string, evaluation: Evaluation, options?: RawAxiosRequestConfig): AxiosPromise<Evaluation> {
            return localVarFp.evaluationsUpdate(id, evaluation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EvaluationsApi - object-oriented interface
 */
export class EvaluationsApi extends BaseAPI {
    /**
     * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
     * @param {string} id 
     * @param {PatchedEvaluation} [patchedEvaluation] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public evaluationsPartialUpdate(id: string, patchedEvaluation?: PatchedEvaluation, options?: RawAxiosRequestConfig) {
        return EvaluationsApiFp(this.configuration).evaluationsPartialUpdate(id, patchedEvaluation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public evaluationsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return EvaluationsApiFp(this.configuration).evaluationsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Created for updating an evaluation by Scoring Function.  As long as evaluation UUID is invisible to users, auth is disabled for simplicity.
     * @param {string} id 
     * @param {Evaluation} evaluation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public evaluationsUpdate(id: string, evaluation: Evaluation, options?: RawAxiosRequestConfig) {
        return EvaluationsApiFp(this.configuration).evaluationsUpdate(id, evaluation, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventApi - axios parameter creator
 */
export const EventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventList: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('eventList', 'courseId', courseId)
            const localVarPath = `/api/Event/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventApi - functional programming interface
 */
export const EventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eventList(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eventList(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventApi.eventList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventApi - factory interface
 */
export const EventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventApiFp(configuration)
    return {
        /**
         * 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventList(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>> {
            return localVarFp.eventList(courseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventApi - object-oriented interface
 */
export class EventApi extends BaseAPI {
    /**
     * 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public eventList(courseId: string, options?: RawAxiosRequestConfig) {
        return EventApiFp(this.configuration).eventList(courseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ForumRecordsApi - axios parameter creator
 */
export const ForumRecordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsCreate: async (forumRecordWithFiles: ForumRecordWithFiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'forumRecordWithFiles' is not null or undefined
            assertParamExists('forumRecordsCreate', 'forumRecordWithFiles', forumRecordWithFiles)
            const localVarPath = `/api/forum-records/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumRecordWithFiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsDestroy', 'id', id)
            const localVarPath = `/api/forum-records/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileSignedUrlRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forum-records/file-signed-url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {ForumFileUpload} forumFileUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileUploadCreate: async (id: string, forumFileUpload: ForumFileUpload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsFileUploadCreate', 'id', id)
            // verify required parameter 'forumFileUpload' is not null or undefined
            assertParamExists('forumRecordsFileUploadCreate', 'forumFileUpload', forumFileUpload)
            const localVarPath = `/api/forum-records/file-upload/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumFileUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileUploadDestroy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsFileUploadDestroy', 'id', id)
            const localVarPath = `/api/forum-records/file-upload/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [course] 
         * @param {boolean} [isAnnouncement] 
         * @param {boolean} [isDeleted] 
         * @param {boolean} [isDraft] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [parentRecord] 
         * @param {boolean} [parentRecordIsnull] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsList: async (course?: string, isAnnouncement?: boolean, isDeleted?: boolean, isDraft?: boolean, limit?: number, offset?: number, ordering?: string, parentRecord?: string, parentRecordIsnull?: boolean, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forum-records/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (isAnnouncement !== undefined) {
                localVarQueryParameter['is_announcement'] = isAnnouncement;
            }

            if (isDeleted !== undefined) {
                localVarQueryParameter['is_deleted'] = isDeleted;
            }

            if (isDraft !== undefined) {
                localVarQueryParameter['is_draft'] = isDraft;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (parentRecord !== undefined) {
                localVarQueryParameter['parent_record'] = parentRecord;
            }

            if (parentRecordIsnull !== undefined) {
                localVarQueryParameter['parent_record__isnull'] = parentRecordIsnull;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {PatchedForumRecordWithFiles} [patchedForumRecordWithFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsPartialUpdate: async (id: string, patchedForumRecordWithFiles?: PatchedForumRecordWithFiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsPartialUpdate', 'id', id)
            const localVarPath = `/api/forum-records/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedForumRecordWithFiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsRetrieve', 'id', id)
            const localVarPath = `/api/forum-records/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsTemplatesRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/forum-records/templates/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsUpdate: async (id: string, forumRecordWithFiles: ForumRecordWithFiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('forumRecordsUpdate', 'id', id)
            // verify required parameter 'forumRecordWithFiles' is not null or undefined
            assertParamExists('forumRecordsUpdate', 'forumRecordWithFiles', forumRecordWithFiles)
            const localVarPath = `/api/forum-records/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forumRecordWithFiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForumRecordsApi - functional programming interface
 */
export const ForumRecordsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForumRecordsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsCreate(forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumRecordWithFiles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsCreate(forumRecordWithFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsFileSignedUrlRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignedURL>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsFileSignedUrlRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsFileSignedUrlRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {ForumFileUpload} forumFileUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsFileUploadCreate(id: string, forumFileUpload: ForumFileUpload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumFileUpload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsFileUploadCreate(id, forumFileUpload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsFileUploadCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsFileUploadDestroy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsFileUploadDestroy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsFileUploadDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [course] 
         * @param {boolean} [isAnnouncement] 
         * @param {boolean} [isDeleted] 
         * @param {boolean} [isDraft] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [parentRecord] 
         * @param {boolean} [parentRecordIsnull] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsList(course?: string, isAnnouncement?: boolean, isDeleted?: boolean, isDraft?: boolean, limit?: number, offset?: number, ordering?: string, parentRecord?: string, parentRecordIsnull?: boolean, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedForumRecordList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsList(course, isAnnouncement, isDeleted, isDraft, limit, offset, ordering, parentRecord, parentRecordIsnull, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {PatchedForumRecordWithFiles} [patchedForumRecordWithFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsPartialUpdate(id: string, patchedForumRecordWithFiles?: PatchedForumRecordWithFiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumRecordWithFiles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsPartialUpdate(id, patchedForumRecordWithFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumRecordWithFiles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsTemplatesRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsTemplatesRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsTemplatesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forumRecordsUpdate(id: string, forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForumRecordWithFiles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forumRecordsUpdate(id, forumRecordWithFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ForumRecordsApi.forumRecordsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ForumRecordsApi - factory interface
 */
export const ForumRecordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForumRecordsApiFp(configuration)
    return {
        /**
         * 
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsCreate(forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig): AxiosPromise<ForumRecordWithFiles> {
            return localVarFp.forumRecordsCreate(forumRecordWithFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forumRecordsDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileSignedUrlRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<SignedURL> {
            return localVarFp.forumRecordsFileSignedUrlRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {ForumFileUpload} forumFileUpload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileUploadCreate(id: string, forumFileUpload: ForumFileUpload, options?: RawAxiosRequestConfig): AxiosPromise<ForumFileUpload> {
            return localVarFp.forumRecordsFileUploadCreate(id, forumFileUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsFileUploadDestroy(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forumRecordsFileUploadDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [course] 
         * @param {boolean} [isAnnouncement] 
         * @param {boolean} [isDeleted] 
         * @param {boolean} [isDraft] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [parentRecord] 
         * @param {boolean} [parentRecordIsnull] 
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsList(course?: string, isAnnouncement?: boolean, isDeleted?: boolean, isDraft?: boolean, limit?: number, offset?: number, ordering?: string, parentRecord?: string, parentRecordIsnull?: boolean, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedForumRecordList> {
            return localVarFp.forumRecordsList(course, isAnnouncement, isDeleted, isDraft, limit, offset, ordering, parentRecord, parentRecordIsnull, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {PatchedForumRecordWithFiles} [patchedForumRecordWithFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsPartialUpdate(id: string, patchedForumRecordWithFiles?: PatchedForumRecordWithFiles, options?: RawAxiosRequestConfig): AxiosPromise<ForumRecordWithFiles> {
            return localVarFp.forumRecordsPartialUpdate(id, patchedForumRecordWithFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ForumRecordWithFiles> {
            return localVarFp.forumRecordsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsTemplatesRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<ForumTemplate> {
            return localVarFp.forumRecordsTemplatesRetrieve(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this forum record.
         * @param {ForumRecordWithFiles} forumRecordWithFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forumRecordsUpdate(id: string, forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig): AxiosPromise<ForumRecordWithFiles> {
            return localVarFp.forumRecordsUpdate(id, forumRecordWithFiles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForumRecordsApi - object-oriented interface
 */
export class ForumRecordsApi extends BaseAPI {
    /**
     * 
     * @param {ForumRecordWithFiles} forumRecordWithFiles 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsCreate(forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsCreate(forumRecordWithFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this forum record.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsFileSignedUrlRetrieve(options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsFileSignedUrlRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {ForumFileUpload} forumFileUpload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsFileUploadCreate(id: string, forumFileUpload: ForumFileUpload, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsFileUploadCreate(id, forumFileUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsFileUploadDestroy(id: string, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsFileUploadDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [course] 
     * @param {boolean} [isAnnouncement] 
     * @param {boolean} [isDeleted] 
     * @param {boolean} [isDraft] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [parentRecord] 
     * @param {boolean} [parentRecordIsnull] 
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsList(course?: string, isAnnouncement?: boolean, isDeleted?: boolean, isDraft?: boolean, limit?: number, offset?: number, ordering?: string, parentRecord?: string, parentRecordIsnull?: boolean, search?: string, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsList(course, isAnnouncement, isDeleted, isDraft, limit, offset, ordering, parentRecord, parentRecordIsnull, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this forum record.
     * @param {PatchedForumRecordWithFiles} [patchedForumRecordWithFiles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsPartialUpdate(id: string, patchedForumRecordWithFiles?: PatchedForumRecordWithFiles, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsPartialUpdate(id, patchedForumRecordWithFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this forum record.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsTemplatesRetrieve(options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsTemplatesRetrieve(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this forum record.
     * @param {ForumRecordWithFiles} forumRecordWithFiles 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forumRecordsUpdate(id: string, forumRecordWithFiles: ForumRecordWithFiles, options?: RawAxiosRequestConfig) {
        return ForumRecordsApiFp(this.configuration).forumRecordsUpdate(id, forumRecordWithFiles, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GkeApi - axios parameter creator
 */
export const GkeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gkeSessionsList: async (endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endAt' is not null or undefined
            assertParamExists('gkeSessionsList', 'endAt', endAt)
            // verify required parameter 'startAt' is not null or undefined
            assertParamExists('gkeSessionsList', 'startAt', startAt)
            const localVarPath = `/api/gke/sessions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseShortId !== undefined) {
                localVarQueryParameter['course_short_id'] = courseShortId;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['max_duration'] = maxDuration;
            }

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gkeStatsList: async (endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endAt' is not null or undefined
            assertParamExists('gkeStatsList', 'endAt', endAt)
            // verify required parameter 'startAt' is not null or undefined
            assertParamExists('gkeStatsList', 'startAt', startAt)
            const localVarPath = `/api/gke/stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courseShortId !== undefined) {
                localVarQueryParameter['course_short_id'] = courseShortId;
            }

            if (endAt !== undefined) {
                localVarQueryParameter['end_at'] = (endAt as any instanceof Date) ?
                    (endAt as any).toISOString() :
                    endAt;
            }

            if (maxDuration !== undefined) {
                localVarQueryParameter['max_duration'] = maxDuration;
            }

            if (startAt !== undefined) {
                localVarQueryParameter['start_at'] = (startAt as any instanceof Date) ?
                    (startAt as any).toISOString() :
                    startAt;
            }

            if (uid !== undefined) {
                localVarQueryParameter['uid'] = uid;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GkeApi - functional programming interface
 */
export const GkeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GkeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gkeSessionsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GkeSessionsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gkeSessionsList(endAt, startAt, courseShortId, maxDuration, uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GkeApi.gkeSessionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gkeStatsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GkeStatsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gkeStatsList(endAt, startAt, courseShortId, maxDuration, uid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GkeApi.gkeStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GkeApi - factory interface
 */
export const GkeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GkeApiFp(configuration)
    return {
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gkeSessionsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GkeSessionsResponse>> {
            return localVarFp.gkeSessionsList(endAt, startAt, courseShortId, maxDuration, uid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Date} endAt 
         * @param {Date} startAt 
         * @param {string} [courseShortId] 
         * @param {string} [maxDuration] 
         * @param {string} [uid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gkeStatsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GkeStatsResponse>> {
            return localVarFp.gkeStatsList(endAt, startAt, courseShortId, maxDuration, uid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GkeApi - object-oriented interface
 */
export class GkeApi extends BaseAPI {
    /**
     * 
     * @param {Date} endAt 
     * @param {Date} startAt 
     * @param {string} [courseShortId] 
     * @param {string} [maxDuration] 
     * @param {string} [uid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gkeSessionsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig) {
        return GkeApiFp(this.configuration).gkeSessionsList(endAt, startAt, courseShortId, maxDuration, uid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Date} endAt 
     * @param {Date} startAt 
     * @param {string} [courseShortId] 
     * @param {string} [maxDuration] 
     * @param {string} [uid] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public gkeStatsList(endAt: Date, startAt: Date, courseShortId?: string, maxDuration?: string, uid?: string, options?: RawAxiosRequestConfig) {
        return GkeApiFp(this.configuration).gkeStatsList(endAt, startAt, courseShortId, maxDuration, uid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LeaderboardApi - axios parameter creator
 */
export const LeaderboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the leaderboard of the specified assignment. This part is terrible in terms of performance...
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaderboardList: async (assignmentId: string, courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('leaderboardList', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('leaderboardList', 'courseId', courseId)
            const localVarPath = `/api/Leaderboard/{assignment_id}/{course_id}`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeaderboardApi - functional programming interface
 */
export const LeaderboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LeaderboardApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the leaderboard of the specified assignment. This part is terrible in terms of performance...
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaderboardList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubmissionListAdmin>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaderboardList(assignmentId, courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LeaderboardApi.leaderboardList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LeaderboardApi - factory interface
 */
export const LeaderboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LeaderboardApiFp(configuration)
    return {
        /**
         * Get the leaderboard of the specified assignment. This part is terrible in terms of performance...
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaderboardList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubmissionListAdmin>> {
            return localVarFp.leaderboardList(assignmentId, courseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LeaderboardApi - object-oriented interface
 */
export class LeaderboardApi extends BaseAPI {
    /**
     * Get the leaderboard of the specified assignment. This part is terrible in terms of performance...
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaderboardList(assignmentId: string, courseId: string, options?: RawAxiosRequestConfig) {
        return LeaderboardApiFp(this.configuration).leaderboardList(assignmentId, courseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProgressReportsApi - axios parameter creator
 */
export const ProgressReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        progressReportsRetrieve: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/progress-reports/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProgressReportsApi - functional programming interface
 */
export const ProgressReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProgressReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async progressReportsRetrieve(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProgressReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.progressReportsRetrieve(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProgressReportsApi.progressReportsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProgressReportsApi - factory interface
 */
export const ProgressReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProgressReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        progressReportsRetrieve(options?: RawAxiosRequestConfig): AxiosPromise<ProgressReport> {
            return localVarFp.progressReportsRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProgressReportsApi - object-oriented interface
 */
export class ProgressReportsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public progressReportsRetrieve(options?: RawAxiosRequestConfig) {
        return ProgressReportsApiFp(this.configuration).progressReportsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PygradeApi - axios parameter creator
 */
export const PygradeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} testId 
         * @param {Answer} [answer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsAnswersCreate: async (testId: string, answer?: Answer, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeExamsAnswersCreate', 'testId', testId)
            const localVarPath = `/api/pygrade/exams/{testId}/answers`
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsList: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pygrade/exams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsProblemsList: async (testId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeExamsProblemsList', 'testId', testId)
            const localVarPath = `/api/pygrade/exams/{testId}/problems`
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsProblemsRetrieve: async (problemId: string, testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'problemId' is not null or undefined
            assertParamExists('pygradeExamsProblemsRetrieve', 'problemId', problemId)
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeExamsProblemsRetrieve', 'testId', testId)
            const localVarPath = `/api/pygrade/exams/{testId}/problems/{problemId}`
                .replace('{problemId}', encodeURIComponent(String(problemId)))
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsRetrieve: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeExamsRetrieve', 'testId', testId)
            const localVarPath = `/api/pygrade/exams/{testId}`
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsList: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/pygrade/trainings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsProblemsList: async (testId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeTrainingsProblemsList', 'testId', testId)
            const localVarPath = `/api/pygrade/trainings/{testId}/problems`
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsProblemsRetrieve: async (problemId: string, testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'problemId' is not null or undefined
            assertParamExists('pygradeTrainingsProblemsRetrieve', 'problemId', problemId)
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeTrainingsProblemsRetrieve', 'testId', testId)
            const localVarPath = `/api/pygrade/trainings/{testId}/problems/{problemId}`
                .replace('{problemId}', encodeURIComponent(String(problemId)))
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsRetrieve: async (testId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('pygradeTrainingsRetrieve', 'testId', testId)
            const localVarPath = `/api/pygrade/trainings/{testId}`
                .replace('{testId}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PygradeApi - functional programming interface
 */
export const PygradeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PygradeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} testId 
         * @param {Answer} [answer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeExamsAnswersCreate(testId: string, answer?: Answer, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Answer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeExamsAnswersCreate(testId, answer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeExamsAnswersCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeExamsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedExamList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeExamsList(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeExamsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeExamsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProblemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeExamsProblemsList(testId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeExamsProblemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeExamsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Problem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeExamsProblemsRetrieve(problemId, testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeExamsProblemsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeExamsRetrieve(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeExamsRetrieve(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeExamsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeTrainingsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedTrainingList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeTrainingsList(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeTrainingsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeTrainingsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedProblemList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeTrainingsProblemsList(testId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeTrainingsProblemsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeTrainingsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Problem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeTrainingsProblemsRetrieve(problemId, testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeTrainingsProblemsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pygradeTrainingsRetrieve(testId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrainingDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pygradeTrainingsRetrieve(testId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PygradeApi.pygradeTrainingsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PygradeApi - factory interface
 */
export const PygradeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PygradeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} testId 
         * @param {Answer} [answer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsAnswersCreate(testId: string, answer?: Answer, options?: RawAxiosRequestConfig): AxiosPromise<Answer> {
            return localVarFp.pygradeExamsAnswersCreate(testId, answer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedExamList> {
            return localVarFp.pygradeExamsList(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProblemList> {
            return localVarFp.pygradeExamsProblemsList(testId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig): AxiosPromise<Problem> {
            return localVarFp.pygradeExamsProblemsRetrieve(problemId, testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeExamsRetrieve(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<ExamDetail> {
            return localVarFp.pygradeExamsRetrieve(testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedTrainingList> {
            return localVarFp.pygradeTrainingsList(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} testId 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedProblemList> {
            return localVarFp.pygradeTrainingsProblemsList(testId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} problemId 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig): AxiosPromise<Problem> {
            return localVarFp.pygradeTrainingsProblemsRetrieve(problemId, testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pygradeTrainingsRetrieve(testId: string, options?: RawAxiosRequestConfig): AxiosPromise<TrainingDetail> {
            return localVarFp.pygradeTrainingsRetrieve(testId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PygradeApi - object-oriented interface
 */
export class PygradeApi extends BaseAPI {
    /**
     * 
     * @param {string} testId 
     * @param {Answer} [answer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeExamsAnswersCreate(testId: string, answer?: Answer, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeExamsAnswersCreate(testId, answer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeExamsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeExamsList(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} testId 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeExamsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeExamsProblemsList(testId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} problemId 
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeExamsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeExamsProblemsRetrieve(problemId, testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeExamsRetrieve(testId: string, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeExamsRetrieve(testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeTrainingsList(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeTrainingsList(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} testId 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeTrainingsProblemsList(testId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeTrainingsProblemsList(testId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} problemId 
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeTrainingsProblemsRetrieve(problemId: string, testId: string, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeTrainingsProblemsRetrieve(problemId, testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public pygradeTrainingsRetrieve(testId: string, options?: RawAxiosRequestConfig) {
        return PygradeApiFp(this.configuration).pygradeTrainingsRetrieve(testId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuizCoursesApi - axios parameter creator
 */
export const QuizCoursesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizCoursesList: async (course?: string, limit?: number, offset?: number, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quiz-courses/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizCoursesApi - functional programming interface
 */
export const QuizCoursesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizCoursesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizCoursesList(course?: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedQuizCourseList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizCoursesList(course, limit, offset, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizCoursesApi.quizCoursesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizCoursesApi - factory interface
 */
export const QuizCoursesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizCoursesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [course] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizCoursesList(course?: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedQuizCourseList> {
            return localVarFp.quizCoursesList(course, limit, offset, ordering, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuizCoursesApi - object-oriented interface
 */
export class QuizCoursesApi extends BaseAPI {
    /**
     * 
     * @param {string} [course] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizCoursesList(course?: string, limit?: number, offset?: number, ordering?: string, options?: RawAxiosRequestConfig) {
        return QuizCoursesApiFp(this.configuration).quizCoursesList(course, limit, offset, ordering, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuizSubmissionsApi - axios parameter creator
 */
export const QuizSubmissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QuizSubmissionCreate} quizSubmissionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsCreateCreate: async (quizSubmissionCreate: QuizSubmissionCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'quizSubmissionCreate' is not null or undefined
            assertParamExists('quizSubmissionsCreateCreate', 'quizSubmissionCreate', quizSubmissionCreate)
            const localVarPath = `/api/quiz-submissions/create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(quizSubmissionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [createdBy] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {number} [quiz] 
         * @param {string} [quizCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsList: async (course?: string, createdBy?: string, limit?: number, offset?: number, quiz?: number, quizCourse?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quiz-submissions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['created_by'] = createdBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (quiz !== undefined) {
                localVarQueryParameter['quiz'] = quiz;
            }

            if (quizCourse !== undefined) {
                localVarQueryParameter['quiz_course'] = quizCourse;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('quizSubmissionsRetrieve', 'id', id)
            const localVarPath = `/api/quiz-submissions/{id}`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizSubmissionsApi - functional programming interface
 */
export const QuizSubmissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizSubmissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QuizSubmissionCreate} quizSubmissionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizSubmissionsCreateCreate(quizSubmissionCreate: QuizSubmissionCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizSubmissionCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizSubmissionsCreateCreate(quizSubmissionCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizSubmissionsApi.quizSubmissionsCreateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [createdBy] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {number} [quiz] 
         * @param {string} [quizCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizSubmissionsList(course?: string, createdBy?: string, limit?: number, offset?: number, quiz?: number, quizCourse?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedQuizSubmissionList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizSubmissionsList(course, createdBy, limit, offset, quiz, quizCourse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizSubmissionsApi.quizSubmissionsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizSubmissionsRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizSubmissionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizSubmissionsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizSubmissionsApi.quizSubmissionsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizSubmissionsApi - factory interface
 */
export const QuizSubmissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizSubmissionsApiFp(configuration)
    return {
        /**
         * 
         * @param {QuizSubmissionCreate} quizSubmissionCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsCreateCreate(quizSubmissionCreate: QuizSubmissionCreate, options?: RawAxiosRequestConfig): AxiosPromise<QuizSubmissionCreate> {
            return localVarFp.quizSubmissionsCreateCreate(quizSubmissionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [course] 
         * @param {string} [createdBy] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {number} [quiz] 
         * @param {string} [quizCourse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsList(course?: string, createdBy?: string, limit?: number, offset?: number, quiz?: number, quizCourse?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedQuizSubmissionList> {
            return localVarFp.quizSubmissionsList(course, createdBy, limit, offset, quiz, quizCourse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizSubmissionsRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizSubmissionDetail> {
            return localVarFp.quizSubmissionsRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuizSubmissionsApi - object-oriented interface
 */
export class QuizSubmissionsApi extends BaseAPI {
    /**
     * 
     * @param {QuizSubmissionCreate} quizSubmissionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizSubmissionsCreateCreate(quizSubmissionCreate: QuizSubmissionCreate, options?: RawAxiosRequestConfig) {
        return QuizSubmissionsApiFp(this.configuration).quizSubmissionsCreateCreate(quizSubmissionCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [course] 
     * @param {string} [createdBy] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {number} [quiz] 
     * @param {string} [quizCourse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizSubmissionsList(course?: string, createdBy?: string, limit?: number, offset?: number, quiz?: number, quizCourse?: string, options?: RawAxiosRequestConfig) {
        return QuizSubmissionsApiFp(this.configuration).quizSubmissionsList(course, createdBy, limit, offset, quiz, quizCourse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizSubmissionsRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return QuizSubmissionsApiFp(this.configuration).quizSubmissionsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuizzesApi - axios parameter creator
 */
export const QuizzesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<string>} [courses] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesList: async (courses?: Array<string>, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/quizzes/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (courses) {
                localVarQueryParameter['courses'] = courses;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('quizzesRetrieve', 'id', id)
            const localVarPath = `/api/quizzes/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuizzesApi - functional programming interface
 */
export const QuizzesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuizzesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<string>} [courses] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizzesList(courses?: Array<string>, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedQuizListList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizzesList(courses, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizzesApi.quizzesList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quizzesRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuizDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quizzesRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuizzesApi.quizzesRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuizzesApi - factory interface
 */
export const QuizzesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuizzesApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<string>} [courses] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesList(courses?: Array<string>, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedQuizListList> {
            return localVarFp.quizzesList(courses, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quizzesRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<QuizDetail> {
            return localVarFp.quizzesRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuizzesApi - object-oriented interface
 */
export class QuizzesApi extends BaseAPI {
    /**
     * 
     * @param {Array<string>} [courses] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizzesList(courses?: Array<string>, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return QuizzesApiFp(this.configuration).quizzesList(courses, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quizzesRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return QuizzesApiFp(this.configuration).quizzesRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SchemaApi - axios parameter creator
 */
export const SchemaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve: async (format?: SchemaRetrieveFormatEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/schema/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            localVarHeaderParameter['Accept'] = 'application/vnd.oai.openapi,application/yaml,application/vnd.oai.openapi+json,application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaApi - functional programming interface
 */
export const SchemaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemaRetrieve(format?: SchemaRetrieveFormatEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemaRetrieve(format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchemaApi.schemaRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchemaApi - factory interface
 */
export const SchemaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaApiFp(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {SchemaRetrieveFormatEnum} [format] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve(format?: SchemaRetrieveFormatEnum, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.schemaRetrieve(format, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaApi - object-oriented interface
 */
export class SchemaApi extends BaseAPI {
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {SchemaRetrieveFormatEnum} [format] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public schemaRetrieve(format?: SchemaRetrieveFormatEnum, options?: RawAxiosRequestConfig) {
        return SchemaApiFp(this.configuration).schemaRetrieve(format, options).then((request) => request(this.axios, this.basePath));
    }
}

export const SchemaRetrieveFormatEnum = {
    Json: 'json',
    Yaml: 'yaml',
} as const;
export type SchemaRetrieveFormatEnum = typeof SchemaRetrieveFormatEnum[keyof typeof SchemaRetrieveFormatEnum];


/**
 * ScoreApi - axios parameter creator
 */
export const ScoreApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Score evaluations with requested testcase.
         * @param {string} courseId 
         * @param {string} testcaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreCreate: async (courseId: string, testcaseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('scoreCreate', 'courseId', courseId)
            // verify required parameter 'testcaseId' is not null or undefined
            assertParamExists('scoreCreate', 'testcaseId', testcaseId)
            const localVarPath = `/api/Score/{testcase_id}/{course_id}`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{testcase_id}', encodeURIComponent(String(testcaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Score evaluations with requested testcase.
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSubmissionSpecificCreate: async (submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('scoreSubmissionSpecificCreate', 'submissionId', submissionId)
            const localVarPath = `/api/Score/{submission_id}/submission_specific/`
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoreApi - functional programming interface
 */
export const ScoreApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoreApiAxiosParamCreator(configuration)
    return {
        /**
         * Score evaluations with requested testcase.
         * @param {string} courseId 
         * @param {string} testcaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreCreate(courseId: string, testcaseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreCreate(courseId, testcaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreApi.scoreCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Score evaluations with requested testcase.
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreSubmissionSpecificCreate(submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreSubmissionSpecificCreate(submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreApi.scoreSubmissionSpecificCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScoreApi - factory interface
 */
export const ScoreApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoreApiFp(configuration)
    return {
        /**
         * Score evaluations with requested testcase.
         * @param {string} courseId 
         * @param {string} testcaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreCreate(courseId: string, testcaseId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.scoreCreate(courseId, testcaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Score evaluations with requested testcase.
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreSubmissionSpecificCreate(submissionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.scoreSubmissionSpecificCreate(submissionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScoreApi - object-oriented interface
 */
export class ScoreApi extends BaseAPI {
    /**
     * Score evaluations with requested testcase.
     * @param {string} courseId 
     * @param {string} testcaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scoreCreate(courseId: string, testcaseId: string, options?: RawAxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreCreate(courseId, testcaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Score evaluations with requested testcase.
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scoreSubmissionSpecificCreate(submissionId: string, options?: RawAxiosRequestConfig) {
        return ScoreApiFp(this.configuration).scoreSubmissionSpecificCreate(submissionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudentListApi - axios parameter creator
 */
export const StudentListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {Student} student 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListCreate: async (courseId: string, student: Student, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('studentListCreate', 'courseId', courseId)
            // verify required parameter 'student' is not null or undefined
            assertParamExists('studentListCreate', 'student', student)
            const localVarPath = `/api/StudentList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(student, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListDestroy: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('studentListDestroy', 'courseId', courseId)
            const localVarPath = `/api/StudentList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListRetrieve: async (courseId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('studentListRetrieve', 'courseId', courseId)
            const localVarPath = `/api/StudentList/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudentListApi - functional programming interface
 */
export const StudentListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudentListApiAxiosParamCreator(configuration)
    return {
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {Student} student 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async studentListCreate(courseId: string, student: Student, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Student>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.studentListCreate(courseId, student, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudentListApi.studentListCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async studentListDestroy(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.studentListDestroy(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudentListApi.studentListDestroy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async studentListRetrieve(courseId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Student>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.studentListRetrieve(courseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudentListApi.studentListRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudentListApi - factory interface
 */
export const StudentListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudentListApiFp(configuration)
    return {
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {Student} student 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListCreate(courseId: string, student: Student, options?: RawAxiosRequestConfig): AxiosPromise<Student> {
            return localVarFp.studentListCreate(courseId, student, options).then((request) => request(axios, basePath));
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListDestroy(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.studentListDestroy(courseId, options).then((request) => request(axios, basePath));
        },
        /**
         * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
         * @param {string} courseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        studentListRetrieve(courseId: string, options?: RawAxiosRequestConfig): AxiosPromise<Student> {
            return localVarFp.studentListRetrieve(courseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudentListApi - object-oriented interface
 */
export class StudentListApi extends BaseAPI {
    /**
     * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
     * @param {string} courseId 
     * @param {Student} student 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public studentListCreate(courseId: string, student: Student, options?: RawAxiosRequestConfig) {
        return StudentListApiFp(this.configuration).studentListCreate(courseId, student, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public studentListDestroy(courseId: string, options?: RawAxiosRequestConfig) {
        return StudentListApiFp(this.configuration).studentListDestroy(courseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * GET: Retrieve a list of students relevant to a course. POST: Add a student by email to a course.
     * @param {string} courseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public studentListRetrieve(courseId: string, options?: RawAxiosRequestConfig) {
        return StudentListApiFp(this.configuration).studentListRetrieve(courseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubmissionApi - axios parameter creator
 */
export const SubmissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionByCourseCourseList: async (courseId: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('submissionByCourseCourseList', 'courseId', courseId)
            const localVarPath = `/api/Submission/by-course/course/{course_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} userId ID of the user
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionByCourseCourseUserList: async (courseId: string, userId: string, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('submissionByCourseCourseUserList', 'courseId', courseId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('submissionByCourseCourseUserList', 'userId', userId)
            const localVarPath = `/api/Submission/by-course/course/{course_id}/user/{user_id}/`
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isFinal] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionList: async (isFinal?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Submission/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isFinal !== undefined) {
                localVarQueryParameter['is_final'] = isFinal;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id A UUID string identifying this submission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submissionRetrieve', 'id', id)
            const localVarPath = `/api/Submission/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSelectFinalCreate: async (assignmentId: string, courseId: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('submissionSelectFinalCreate', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('submissionSelectFinalCreate', 'courseId', courseId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('submissionSelectFinalCreate', 'submissionId', submissionId)
            const localVarPath = `/api/Submission/SelectFinal/{assignment_id}/{course_id}/{submission_id}/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSelectFinalRetrieve: async (assignmentId: string, courseId: string, submissionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignmentId' is not null or undefined
            assertParamExists('submissionSelectFinalRetrieve', 'assignmentId', assignmentId)
            // verify required parameter 'courseId' is not null or undefined
            assertParamExists('submissionSelectFinalRetrieve', 'courseId', courseId)
            // verify required parameter 'submissionId' is not null or undefined
            assertParamExists('submissionSelectFinalRetrieve', 'submissionId', submissionId)
            const localVarPath = `/api/Submission/SelectFinal/{assignment_id}/{course_id}/{submission_id}/`
                .replace('{assignment_id}', encodeURIComponent(String(assignmentId)))
                .replace('{course_id}', encodeURIComponent(String(courseId)))
                .replace('{submission_id}', encodeURIComponent(String(submissionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the submissions from users with the ilect-colab library. See /client of this repository to check that library.
         * @param {SubmissionDetailed} submissionDetailed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSubmitCreate: async (submissionDetailed: SubmissionDetailed, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionDetailed' is not null or undefined
            assertParamExists('submissionSubmitCreate', 'submissionDetailed', submissionDetailed)
            const localVarPath = `/api/Submission/Submit/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionDetailed, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionApi - functional programming interface
 */
export const SubmissionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionByCourseCourseList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentAssignmentList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionByCourseCourseList(courseId, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionByCourseCourseList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} userId ID of the user
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionByCourseCourseUserList(courseId: string, userId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentAssignmentDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionByCourseCourseUserList(courseId, userId, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionByCourseCourseUserList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isFinal] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionList(isFinal?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSubmissionListList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionList(isFinal, limit, offset, ordering, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id A UUID string identifying this submission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionSelectFinalCreate(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionSelectFinalCreate(assignmentId, courseId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionSelectFinalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionSelectFinalRetrieve(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionSelectFinalRetrieve(assignmentId, courseId, submissionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionSelectFinalRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the submissions from users with the ilect-colab library. See /client of this repository to check that library.
         * @param {SubmissionDetailed} submissionDetailed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submissionSubmitCreate(submissionDetailed: SubmissionDetailed, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubmissionDetailed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submissionSubmitCreate(submissionDetailed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionApi.submissionSubmitCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubmissionApi - factory interface
 */
export const SubmissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionApiFp(configuration)
    return {
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionByCourseCourseList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentAssignmentList>> {
            return localVarFp.submissionByCourseCourseList(courseId, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} courseId ID of the course
         * @param {string} userId ID of the user
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionByCourseCourseUserList(courseId: string, userId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AssessmentAssignmentDetail>> {
            return localVarFp.submissionByCourseCourseUserList(courseId, userId, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isFinal] 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {string} [search] A search term.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionList(isFinal?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedSubmissionListList> {
            return localVarFp.submissionList(isFinal, limit, offset, ordering, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id A UUID string identifying this submission.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDetailed> {
            return localVarFp.submissionRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSelectFinalCreate(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submissionSelectFinalCreate(assignmentId, courseId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} assignmentId 
         * @param {string} courseId 
         * @param {string} submissionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSelectFinalRetrieve(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.submissionSelectFinalRetrieve(assignmentId, courseId, submissionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the submissions from users with the ilect-colab library. See /client of this repository to check that library.
         * @param {SubmissionDetailed} submissionDetailed 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submissionSubmitCreate(submissionDetailed: SubmissionDetailed, options?: RawAxiosRequestConfig): AxiosPromise<SubmissionDetailed> {
            return localVarFp.submissionSubmitCreate(submissionDetailed, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmissionApi - object-oriented interface
 */
export class SubmissionApi extends BaseAPI {
    /**
     * 
     * @param {string} courseId ID of the course
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionByCourseCourseList(courseId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionByCourseCourseList(courseId, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} courseId ID of the course
     * @param {string} userId ID of the user
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionByCourseCourseUserList(courseId: string, userId: string, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionByCourseCourseUserList(courseId, userId, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isFinal] 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {string} [search] A search term.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionList(isFinal?: boolean, limit?: number, offset?: number, ordering?: string, search?: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionList(isFinal, limit, offset, ordering, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id A UUID string identifying this submission.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionSelectFinalCreate(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionSelectFinalCreate(assignmentId, courseId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} assignmentId 
     * @param {string} courseId 
     * @param {string} submissionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionSelectFinalRetrieve(assignmentId: string, courseId: string, submissionId: string, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionSelectFinalRetrieve(assignmentId, courseId, submissionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the submissions from users with the ilect-colab library. See /client of this repository to check that library.
     * @param {SubmissionDetailed} submissionDetailed 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submissionSubmitCreate(submissionDetailed: SubmissionDetailed, options?: RawAxiosRequestConfig) {
        return SubmissionApiFp(this.configuration).submissionSubmitCreate(submissionDetailed, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VideoStatsApi - axios parameter creator
 */
export const VideoStatsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsCreate: async (videoStats: VideoStats, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoStats' is not null or undefined
            assertParamExists('videoStatsCreate', 'videoStats', videoStats)
            const localVarPath = `/api/video-stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoStats, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [user] 
         * @param {string} [video] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsList: async (limit?: number, offset?: number, user?: string, video?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/video-stats/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (user !== undefined) {
                localVarQueryParameter['user'] = user;
            }

            if (video !== undefined) {
                localVarQueryParameter['video'] = video;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {PatchedVideoStats} [patchedVideoStats] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsPartialUpdate: async (id: number, patchedVideoStats?: PatchedVideoStats, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videoStatsPartialUpdate', 'id', id)
            const localVarPath = `/api/video-stats/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedVideoStats, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsRetrieve: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videoStatsRetrieve', 'id', id)
            const localVarPath = `/api/video-stats/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsUpdate: async (id: number, videoStats: VideoStats, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('videoStatsUpdate', 'id', id)
            // verify required parameter 'videoStats' is not null or undefined
            assertParamExists('videoStatsUpdate', 'videoStats', videoStats)
            const localVarPath = `/api/video-stats/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoStats, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VideoStatsApi - functional programming interface
 */
export const VideoStatsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VideoStatsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async videoStatsCreate(videoStats: VideoStats, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.videoStatsCreate(videoStats, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoStatsApi.videoStatsCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [user] 
         * @param {string} [video] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async videoStatsList(limit?: number, offset?: number, user?: string, video?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedVideoStatsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.videoStatsList(limit, offset, user, video, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoStatsApi.videoStatsList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {PatchedVideoStats} [patchedVideoStats] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async videoStatsPartialUpdate(id: number, patchedVideoStats?: PatchedVideoStats, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.videoStatsPartialUpdate(id, patchedVideoStats, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoStatsApi.videoStatsPartialUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async videoStatsRetrieve(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.videoStatsRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoStatsApi.videoStatsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async videoStatsUpdate(id: number, videoStats: VideoStats, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.videoStatsUpdate(id, videoStats, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VideoStatsApi.videoStatsUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VideoStatsApi - factory interface
 */
export const VideoStatsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VideoStatsApiFp(configuration)
    return {
        /**
         * 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsCreate(videoStats: VideoStats, options?: RawAxiosRequestConfig): AxiosPromise<VideoStats> {
            return localVarFp.videoStatsCreate(videoStats, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] Number of results to return per page.
         * @param {number} [offset] The initial index from which to return the results.
         * @param {string} [user] 
         * @param {string} [video] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsList(limit?: number, offset?: number, user?: string, video?: string, options?: RawAxiosRequestConfig): AxiosPromise<PaginatedVideoStatsList> {
            return localVarFp.videoStatsList(limit, offset, user, video, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {PatchedVideoStats} [patchedVideoStats] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsPartialUpdate(id: number, patchedVideoStats?: PatchedVideoStats, options?: RawAxiosRequestConfig): AxiosPromise<VideoStats> {
            return localVarFp.videoStatsPartialUpdate(id, patchedVideoStats, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsRetrieve(id: number, options?: RawAxiosRequestConfig): AxiosPromise<VideoStats> {
            return localVarFp.videoStatsRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {VideoStats} videoStats 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        videoStatsUpdate(id: number, videoStats: VideoStats, options?: RawAxiosRequestConfig): AxiosPromise<VideoStats> {
            return localVarFp.videoStatsUpdate(id, videoStats, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VideoStatsApi - object-oriented interface
 */
export class VideoStatsApi extends BaseAPI {
    /**
     * 
     * @param {VideoStats} videoStats 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public videoStatsCreate(videoStats: VideoStats, options?: RawAxiosRequestConfig) {
        return VideoStatsApiFp(this.configuration).videoStatsCreate(videoStats, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] Number of results to return per page.
     * @param {number} [offset] The initial index from which to return the results.
     * @param {string} [user] 
     * @param {string} [video] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public videoStatsList(limit?: number, offset?: number, user?: string, video?: string, options?: RawAxiosRequestConfig) {
        return VideoStatsApiFp(this.configuration).videoStatsList(limit, offset, user, video, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {PatchedVideoStats} [patchedVideoStats] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public videoStatsPartialUpdate(id: number, patchedVideoStats?: PatchedVideoStats, options?: RawAxiosRequestConfig) {
        return VideoStatsApiFp(this.configuration).videoStatsPartialUpdate(id, patchedVideoStats, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public videoStatsRetrieve(id: number, options?: RawAxiosRequestConfig) {
        return VideoStatsApiFp(this.configuration).videoStatsRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {VideoStats} videoStats 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public videoStatsUpdate(id: number, videoStats: VideoStats, options?: RawAxiosRequestConfig) {
        return VideoStatsApiFp(this.configuration).videoStatsUpdate(id, videoStats, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VimeoVideosApi - axios parameter creator
 */
export const VimeoVideosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves all Vimeo videos for courses, with filters.  Requires admin, or student or editor group permission.
         * @param {string} [course] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosList: async (course?: string, name?: string, ordering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/vimeo-videos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (course !== undefined) {
                localVarQueryParameter['course'] = course;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (ordering !== undefined) {
                localVarQueryParameter['ordering'] = ordering;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single VimeoVideo object, only with name field.
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosNameRetrieve: async (videoId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'videoId' is not null or undefined
            assertParamExists('vimeoVideosNameRetrieve', 'videoId', videoId)
            const localVarPath = `/api/vimeo-videos/{video_id}/name`
                .replace('{video_id}', encodeURIComponent(String(videoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PUT: Sync (Create or update) videos from vimeo.com
         * @param {VimeoVideoSync} vimeoVideoSync 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosSyncUpdate: async (vimeoVideoSync: VimeoVideoSync, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vimeoVideoSync' is not null or undefined
            assertParamExists('vimeoVideosSyncUpdate', 'vimeoVideoSync', vimeoVideoSync)
            const localVarPath = `/api/vimeo-videos/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vimeoVideoSync, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VimeoVideosApi - functional programming interface
 */
export const VimeoVideosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VimeoVideosApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves all Vimeo videos for courses, with filters.  Requires admin, or student or editor group permission.
         * @param {string} [course] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vimeoVideosList(course?: string, name?: string, ordering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VimeoVideo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vimeoVideosList(course, name, ordering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VimeoVideosApi.vimeoVideosList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a single VimeoVideo object, only with name field.
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vimeoVideosNameRetrieve(videoId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VimeoVideoNameOnly>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vimeoVideosNameRetrieve(videoId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VimeoVideosApi.vimeoVideosNameRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PUT: Sync (Create or update) videos from vimeo.com
         * @param {VimeoVideoSync} vimeoVideoSync 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vimeoVideosSyncUpdate(vimeoVideoSync: VimeoVideoSync, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VimeoVideoSync>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vimeoVideosSyncUpdate(vimeoVideoSync, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VimeoVideosApi.vimeoVideosSyncUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VimeoVideosApi - factory interface
 */
export const VimeoVideosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VimeoVideosApiFp(configuration)
    return {
        /**
         * Retrieves all Vimeo videos for courses, with filters.  Requires admin, or student or editor group permission.
         * @param {string} [course] 
         * @param {string} [name] 
         * @param {string} [ordering] Which field to use when ordering the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosList(course?: string, name?: string, ordering?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VimeoVideo>> {
            return localVarFp.vimeoVideosList(course, name, ordering, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single VimeoVideo object, only with name field.
         * @param {string} videoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosNameRetrieve(videoId: string, options?: RawAxiosRequestConfig): AxiosPromise<VimeoVideoNameOnly> {
            return localVarFp.vimeoVideosNameRetrieve(videoId, options).then((request) => request(axios, basePath));
        },
        /**
         * PUT: Sync (Create or update) videos from vimeo.com
         * @param {VimeoVideoSync} vimeoVideoSync 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vimeoVideosSyncUpdate(vimeoVideoSync: VimeoVideoSync, options?: RawAxiosRequestConfig): AxiosPromise<VimeoVideoSync> {
            return localVarFp.vimeoVideosSyncUpdate(vimeoVideoSync, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VimeoVideosApi - object-oriented interface
 */
export class VimeoVideosApi extends BaseAPI {
    /**
     * Retrieves all Vimeo videos for courses, with filters.  Requires admin, or student or editor group permission.
     * @param {string} [course] 
     * @param {string} [name] 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public vimeoVideosList(course?: string, name?: string, ordering?: string, options?: RawAxiosRequestConfig) {
        return VimeoVideosApiFp(this.configuration).vimeoVideosList(course, name, ordering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single VimeoVideo object, only with name field.
     * @param {string} videoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public vimeoVideosNameRetrieve(videoId: string, options?: RawAxiosRequestConfig) {
        return VimeoVideosApiFp(this.configuration).vimeoVideosNameRetrieve(videoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PUT: Sync (Create or update) videos from vimeo.com
     * @param {VimeoVideoSync} vimeoVideoSync 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public vimeoVideosSyncUpdate(vimeoVideoSync: VimeoVideoSync, options?: RawAxiosRequestConfig) {
        return VimeoVideosApiFp(this.configuration).vimeoVideosSyncUpdate(vimeoVideoSync, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkbookConfigApi - axios parameter creator
 */
export const WorkbookConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workbookConfigList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/WorkbookConfig/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a WorkbookConfig instance, and user\'s workbook usage on current month.
         * @param {string} id A UUID string identifying this workbook config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workbookConfigRetrieve: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workbookConfigRetrieve', 'id', id)
            const localVarPath = `/api/WorkbookConfig/{id}/`
                .replace('{id}', encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkbookConfigApi - functional programming interface
 */
export const WorkbookConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkbookConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workbookConfigList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkbookConfigList>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workbookConfigList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkbookConfigApi.workbookConfigList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a WorkbookConfig instance, and user\'s workbook usage on current month.
         * @param {string} id A UUID string identifying this workbook config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workbookConfigRetrieve(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkbookConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workbookConfigRetrieve(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkbookConfigApi.workbookConfigRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkbookConfigApi - factory interface
 */
export const WorkbookConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkbookConfigApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workbookConfigList(options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkbookConfigList>> {
            return localVarFp.workbookConfigList(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a WorkbookConfig instance, and user\'s workbook usage on current month.
         * @param {string} id A UUID string identifying this workbook config.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workbookConfigRetrieve(id: string, options?: RawAxiosRequestConfig): AxiosPromise<WorkbookConfig> {
            return localVarFp.workbookConfigRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkbookConfigApi - object-oriented interface
 */
export class WorkbookConfigApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workbookConfigList(options?: RawAxiosRequestConfig) {
        return WorkbookConfigApiFp(this.configuration).workbookConfigList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a WorkbookConfig instance, and user\'s workbook usage on current month.
     * @param {string} id A UUID string identifying this workbook config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workbookConfigRetrieve(id: string, options?: RawAxiosRequestConfig) {
        return WorkbookConfigApiFp(this.configuration).workbookConfigRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}



